// @ts-nocheck

/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * hypeit-auth-service
 * OpenAPI spec version: 1.1.12
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApiPermissionRequestType,
  CanResetPasswordUser500,
  CanResetPasswordUserRequestType,
  ChangePasswordUser500,
  ChangePasswordUserRequestType,
  CheckHost500,
  CheckHostResponseType,
  CheckToken500,
  CheckTokenResponseType,
  ClearCache500,
  ClearCacheRequestType,
  CreateDevice500,
  CreateDeviceRequestType,
  CreateDeviceTokenResponseType,
  CreateGroup500,
  CreateGroupRequestType,
  CreateGroupUsersRequestType,
  CreateModule500,
  CreateModuleRequestType,
  CreatePermission500,
  CreatePermissionRequestType,
  CreateUser500,
  CreateUserRequestType,
  CreateUserResponseType,
  DeleteDevice500,
  DeleteDevices500,
  DeleteDevicesRequestType,
  DeleteGroup500,
  DeleteGroupUsers500,
  DeleteModule500,
  DeletePermission500,
  DeleteUserGroups500,
  EmptyRequestType,
  EmptyResponseType,
  FindAllDevicePlatforms500,
  FindAllDevicePlatformsResponseType,
  FindAllDeviceTokens500,
  FindAllDeviceTokensParams,
  FindAllDeviceTokensReponseType,
  FindAllDeviceWebsocketTopics500,
  FindAllDeviceWebsocketTopicsResponseType,
  FindAllDevices500,
  FindAllDevicesParams,
  FindAllDevicesResponseType,
  FindAllDevicesType,
  FindAllGroupPermissions500,
  FindAllGroupPermissionsResponseType,
  FindAllGroupUsers500,
  FindAllGroupUsersParams,
  FindAllGroupUsersResponseType,
  FindAllGroups500,
  FindAllGroupsParams,
  FindAllGroupsResponseType,
  FindAllModulePermissions500,
  FindAllModulePermissionsParams,
  FindAllModulePermissionsResponseType,
  FindAllModuleTenants500,
  FindAllModuleTenantsParams,
  FindAllModuleTenantsResponseType,
  FindAllModules500,
  FindAllModulesParams,
  FindAllModulesResponseType,
  FindAllPermissions500,
  FindAllPermissionsParams,
  FindAllPermissionsResponseType,
  FindAllTenantModules500,
  FindAllTenantModulesParams,
  FindAllTenantModulesRequestType,
  FindAllTenantModulesResponseType,
  FindAllUserGroups500,
  FindAllUserGroupsParams,
  FindAllUserGroupsResponseType,
  FindAllUsers500,
  FindAllUsersParams,
  FindAllUsersResponseType,
  FindDeviceById500,
  FindDeviceByIdResponseType,
  FindGroupById500,
  FindGroupByIdResponseType,
  FindModuleById500,
  FindModuleByIdResponseType,
  FindOwnActiveSessions500,
  FindOwnActiveSessionsResponseType,
  FindOwnPermissions500,
  FindOwnTenants500,
  FindOwnTenantsResponseType,
  FindOwnUser500,
  FindPermissionById500,
  FindPermissionsByIdResponseType,
  FindUserById500,
  FindUserByIdResponseType,
  GenerateDeviceToken500,
  HealthCheck200,
  HealthCheck500,
  InvalidateSessionOfOwnUser500,
  LoginUser500,
  LoginUserRequestType,
  LoginUserResponseType,
  LogoutDevice500,
  LogoutMe500,
  PermissionInfos500,
  ReconfirmPasswordMe500,
  ReconfirmPasswordUserRequestType,
  RefreshToken500,
  RefreshTokenResponseType,
  RegisterDevice500,
  RegisterDeviceRequestType,
  RegisterDeviceResponseType,
  RemoveUserFromTenantResponseType,
  RemoveUserTenants500,
  RemoveUserTenantsRequestType,
  RequestResetPasswordUser500,
  RequestResetPasswordUserRequestType,
  RequireResetPasswortUser500,
  ResetPasswordResponseType,
  ResetPasswordUser500,
  ResetPasswordUserRequestType,
  SaveGroupPermissions500,
  SaveGroupPermissionsRequestType,
  SaveGroupUsers500,
  SaveModulePermissions500,
  SaveModulePermissionsRequestType,
  SaveModuleTenants500,
  SaveModuleTenantsRequestType,
  SaveTenantModules500,
  SaveUserGroups500,
  SaveUserGroupsRequestType1,
  TopicPermissionInfosReponseType,
  TopicPermissionInfosRequestType,
  UpdateDevice500,
  UpdateDeviceRequestType,
  UpdateGroup500,
  UpdateGroupRequestType,
  UpdateModule500,
  UpdateModuleRequestType,
  UpdatePermission500,
  UpdatePermissionRequestType,
  UpdateUser500,
  UpdateUserRequestType,
  UpdateUserResponseType,
  UserPermissionsResponseType
} from './types';

import { customInstance } from '../../custom-instance';
import type { ErrorType , BodyType } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Check if the given origin is associated with tenant and return a tenant token for later authentication
 * @summary Check Host
 */
export const checkHost = (
    emptyRequestType?: BodyType<EmptyRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CheckHostResponseType>(
      {url: `/auth-service-v1/auth/check-host`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emptyRequestType, signal
    },
      options);
    }




export const getCheckHostQueryKey = (emptyRequestType?: BodyType<EmptyRequestType>,) => {
    return [
    'POST', 'auth-service-v1','auth','check-host', emptyRequestType
    ] as const;
    }


export const getCheckHostQueryOptions = <TData = Awaited<ReturnType<typeof checkHost>>, TError = ErrorType<CheckHost500>>(emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckHostQueryKey(emptyRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkHost>>> = ({ signal }) => checkHost(emptyRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckHostQueryResult = NonNullable<Awaited<ReturnType<typeof checkHost>>>
export type CheckHostQueryError = ErrorType<CheckHost500>


export function useCheckHost<TData = Awaited<ReturnType<typeof checkHost>>, TError = ErrorType<CheckHost500>>(
 emptyRequestType: undefined |  BodyType<EmptyRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkHost>>,
          TError,
          Awaited<ReturnType<typeof checkHost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckHost<TData = Awaited<ReturnType<typeof checkHost>>, TError = ErrorType<CheckHost500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkHost>>,
          TError,
          Awaited<ReturnType<typeof checkHost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckHost<TData = Awaited<ReturnType<typeof checkHost>>, TError = ErrorType<CheckHost500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Host
 */

export function useCheckHost<TData = Awaited<ReturnType<typeof checkHost>>, TError = ErrorType<CheckHost500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkHost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckHostQueryOptions(emptyRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Check Token
 */
export const checkToken = (
    apiPermissionRequestType?: BodyType<ApiPermissionRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CheckTokenResponseType>(
      {url: `/auth-service-v1/auth/check-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: apiPermissionRequestType, signal
    },
      options);
    }




export const getCheckTokenQueryKey = (apiPermissionRequestType?: BodyType<ApiPermissionRequestType>,) => {
    return [
    'POST', 'auth-service-v1','auth','check-token', apiPermissionRequestType
    ] as const;
    }


export const getCheckTokenQueryOptions = <TData = Awaited<ReturnType<typeof checkToken>>, TError = ErrorType<CheckToken500>>(apiPermissionRequestType?: BodyType<ApiPermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckTokenQueryKey(apiPermissionRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkToken>>> = ({ signal }) => checkToken(apiPermissionRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckTokenQueryResult = NonNullable<Awaited<ReturnType<typeof checkToken>>>
export type CheckTokenQueryError = ErrorType<CheckToken500>


export function useCheckToken<TData = Awaited<ReturnType<typeof checkToken>>, TError = ErrorType<CheckToken500>>(
 apiPermissionRequestType: undefined |  BodyType<ApiPermissionRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkToken>>,
          TError,
          Awaited<ReturnType<typeof checkToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckToken<TData = Awaited<ReturnType<typeof checkToken>>, TError = ErrorType<CheckToken500>>(
 apiPermissionRequestType?: BodyType<ApiPermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkToken>>,
          TError,
          Awaited<ReturnType<typeof checkToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckToken<TData = Awaited<ReturnType<typeof checkToken>>, TError = ErrorType<CheckToken500>>(
 apiPermissionRequestType?: BodyType<ApiPermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Token
 */

export function useCheckToken<TData = Awaited<ReturnType<typeof checkToken>>, TError = ErrorType<CheckToken500>>(
 apiPermissionRequestType?: BodyType<ApiPermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckTokenQueryOptions(apiPermissionRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Refresh Token
 */
export const refreshToken = (
    emptyRequestType?: BodyType<EmptyRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RefreshTokenResponseType>(
      {url: `/auth-service-v1/auth/refresh-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emptyRequestType, signal
    },
      options);
    }




export const getRefreshTokenQueryKey = (emptyRequestType?: BodyType<EmptyRequestType>,) => {
    return [
    'POST', 'auth-service-v1','auth','refresh-token', emptyRequestType
    ] as const;
    }


export const getRefreshTokenQueryOptions = <TData = Awaited<ReturnType<typeof refreshToken>>, TError = ErrorType<RefreshToken500>>(emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRefreshTokenQueryKey(emptyRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof refreshToken>>> = ({ signal }) => refreshToken(emptyRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RefreshTokenQueryResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>
export type RefreshTokenQueryError = ErrorType<RefreshToken500>


export function useRefreshToken<TData = Awaited<ReturnType<typeof refreshToken>>, TError = ErrorType<RefreshToken500>>(
 emptyRequestType: undefined |  BodyType<EmptyRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshToken>>,
          TError,
          Awaited<ReturnType<typeof refreshToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshToken<TData = Awaited<ReturnType<typeof refreshToken>>, TError = ErrorType<RefreshToken500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshToken>>,
          TError,
          Awaited<ReturnType<typeof refreshToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshToken<TData = Awaited<ReturnType<typeof refreshToken>>, TError = ErrorType<RefreshToken500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Refresh Token
 */

export function useRefreshToken<TData = Awaited<ReturnType<typeof refreshToken>>, TError = ErrorType<RefreshToken500>>(
 emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRefreshTokenQueryOptions(emptyRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Clear the entire cache or only specific entities (CONSOLE only)
 * @summary Clear Cache
 */
export const clearCache = (
    clearCacheRequestType?: BodyType<ClearCacheRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/auth/clear-cache`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clearCacheRequestType, signal
    },
      options);
    }




export const getClearCacheQueryKey = (clearCacheRequestType?: BodyType<ClearCacheRequestType>,) => {
    return [
    'POST', 'auth-service-v1','auth','clear-cache', clearCacheRequestType
    ] as const;
    }


export const getClearCacheQueryOptions = <TData = Awaited<ReturnType<typeof clearCache>>, TError = ErrorType<ClearCache500>>(clearCacheRequestType?: BodyType<ClearCacheRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClearCacheQueryKey(clearCacheRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clearCache>>> = ({ signal }) => clearCache(clearCacheRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClearCacheQueryResult = NonNullable<Awaited<ReturnType<typeof clearCache>>>
export type ClearCacheQueryError = ErrorType<ClearCache500>


export function useClearCache<TData = Awaited<ReturnType<typeof clearCache>>, TError = ErrorType<ClearCache500>>(
 clearCacheRequestType: undefined |  BodyType<ClearCacheRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clearCache>>,
          TError,
          Awaited<ReturnType<typeof clearCache>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClearCache<TData = Awaited<ReturnType<typeof clearCache>>, TError = ErrorType<ClearCache500>>(
 clearCacheRequestType?: BodyType<ClearCacheRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clearCache>>,
          TError,
          Awaited<ReturnType<typeof clearCache>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClearCache<TData = Awaited<ReturnType<typeof clearCache>>, TError = ErrorType<ClearCache500>>(
 clearCacheRequestType?: BodyType<ClearCacheRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Clear Cache
 */

export function useClearCache<TData = Awaited<ReturnType<typeof clearCache>>, TError = ErrorType<ClearCache500>>(
 clearCacheRequestType?: BodyType<ClearCacheRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clearCache>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClearCacheQueryOptions(clearCacheRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Register a Device with a Device-token. The server generates a UUID for later authenticated communication by header.
 * @summary Register Device
 */
export const registerDevice = (
    registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RegisterDeviceResponseType>(
      {url: `/auth-service-v1/device-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDeviceRequestType, signal
    },
      options);
    }




export const getRegisterDeviceQueryKey = (registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>,) => {
    return [
    'POST', 'auth-service-v1','device-tokens', registerDeviceRequestType
    ] as const;
    }


export const getRegisterDeviceQueryOptions = <TData = Awaited<ReturnType<typeof registerDevice>>, TError = ErrorType<RegisterDevice500>>(registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegisterDeviceQueryKey(registerDeviceRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof registerDevice>>> = ({ signal }) => registerDevice(registerDeviceRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegisterDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof registerDevice>>>
export type RegisterDeviceQueryError = ErrorType<RegisterDevice500>


export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ErrorType<RegisterDevice500>>(
 registerDeviceRequestType: undefined |  BodyType<RegisterDeviceRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerDevice>>,
          TError,
          Awaited<ReturnType<typeof registerDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ErrorType<RegisterDevice500>>(
 registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerDevice>>,
          TError,
          Awaited<ReturnType<typeof registerDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ErrorType<RegisterDevice500>>(
 registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Register Device
 */

export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ErrorType<RegisterDevice500>>(
 registerDeviceRequestType?: BodyType<RegisterDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegisterDeviceQueryOptions(registerDeviceRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get All device registration codes as list

Permissions: ADMIN_DEVICES = 21 (READ)
 * @summary Find All DeviceTokens
 */
export const findAllDeviceTokens = (
    params?: FindAllDeviceTokensParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDeviceTokensReponseType>(
      {url: `/auth-service-v1/device-tokens`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllDeviceTokensQueryKey = (params?: FindAllDeviceTokensParams,) => {
    return [
    'auth-service-v1','device-tokens', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllDeviceTokensQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDeviceTokensQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeviceTokens>>> = ({ signal }) => findAllDeviceTokens(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDeviceTokensQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeviceTokens>>>
export type FindAllDeviceTokensQueryError = ErrorType<FindAllDeviceTokens500>


export function useFindAllDeviceTokens<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params: undefined |  FindAllDeviceTokensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeviceTokens>>,
          TError,
          Awaited<ReturnType<typeof findAllDeviceTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceTokens<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeviceTokens>>,
          TError,
          Awaited<ReturnType<typeof findAllDeviceTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceTokens<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All DeviceTokens
 */

export function useFindAllDeviceTokens<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDeviceTokensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllDeviceTokensSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDeviceTokensQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeviceTokens>>> = ({ signal }) => findAllDeviceTokens(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDeviceTokensSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeviceTokens>>>
export type FindAllDeviceTokensSuspenseQueryError = ErrorType<FindAllDeviceTokens500>


export function useFindAllDeviceTokensSuspense<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params: undefined |  FindAllDeviceTokensParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceTokensSuspense<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceTokensSuspense<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All DeviceTokens
 */

export function useFindAllDeviceTokensSuspense<TData = Awaited<ReturnType<typeof findAllDeviceTokens>>, TError = ErrorType<FindAllDeviceTokens500>>(
 params?: FindAllDeviceTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDeviceTokensSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Generate a Device Registration Code for the App (server generated Identifier) that will be saved with the client-generated ID and tenantId to identify an Device.

Permissions: ADMIN_DEVICES = 21 (WRITE)
 * @summary Generate Device Registration Code
 */
export const generateDeviceToken = (
    id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateDeviceTokenResponseType>(
      {url: `/auth-service-v1/devices/${id}/device-registration-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emptyRequestType, signal
    },
      options);
    }




export const getGenerateDeviceTokenQueryKey = (id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,) => {
    return [
    'POST', 'auth-service-v1','devices',id,'device-registration-codes', emptyRequestType
    ] as const;
    }


export const getGenerateDeviceTokenQueryOptions = <TData = Awaited<ReturnType<typeof generateDeviceToken>>, TError = ErrorType<GenerateDeviceToken500>>(id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenerateDeviceTokenQueryKey(id,emptyRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof generateDeviceToken>>> = ({ signal }) => generateDeviceToken(id,emptyRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GenerateDeviceTokenQueryResult = NonNullable<Awaited<ReturnType<typeof generateDeviceToken>>>
export type GenerateDeviceTokenQueryError = ErrorType<GenerateDeviceToken500>


export function useGenerateDeviceToken<TData = Awaited<ReturnType<typeof generateDeviceToken>>, TError = ErrorType<GenerateDeviceToken500>>(
 id: string,
    emptyRequestType: undefined |  BodyType<EmptyRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateDeviceToken>>,
          TError,
          Awaited<ReturnType<typeof generateDeviceToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenerateDeviceToken<TData = Awaited<ReturnType<typeof generateDeviceToken>>, TError = ErrorType<GenerateDeviceToken500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateDeviceToken>>,
          TError,
          Awaited<ReturnType<typeof generateDeviceToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGenerateDeviceToken<TData = Awaited<ReturnType<typeof generateDeviceToken>>, TError = ErrorType<GenerateDeviceToken500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate Device Registration Code
 */

export function useGenerateDeviceToken<TData = Awaited<ReturnType<typeof generateDeviceToken>>, TError = ErrorType<GenerateDeviceToken500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateDeviceToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGenerateDeviceTokenQueryOptions(id,emptyRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create a device. Generates and returns a device registration code in the response.

Permissions: ADMIN_DEVICES = 21 (WRITE)
 * @summary Create Device
 */
export const createDevice = (
    createDeviceRequestType?: BodyType<CreateDeviceRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindDeviceByIdResponseType>(
      {url: `/auth-service-v1/devices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDeviceRequestType, signal
    },
      options);
    }




export const getCreateDeviceQueryKey = (createDeviceRequestType?: BodyType<CreateDeviceRequestType>,) => {
    return [
    'POST', 'auth-service-v1','devices', createDeviceRequestType
    ] as const;
    }


export const getCreateDeviceQueryOptions = <TData = Awaited<ReturnType<typeof createDevice>>, TError = ErrorType<CreateDevice500>>(createDeviceRequestType?: BodyType<CreateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateDeviceQueryKey(createDeviceRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createDevice>>> = ({ signal }) => createDevice(createDeviceRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof createDevice>>>
export type CreateDeviceQueryError = ErrorType<CreateDevice500>


export function useCreateDevice<TData = Awaited<ReturnType<typeof createDevice>>, TError = ErrorType<CreateDevice500>>(
 createDeviceRequestType: undefined |  BodyType<CreateDeviceRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createDevice>>,
          TError,
          Awaited<ReturnType<typeof createDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateDevice<TData = Awaited<ReturnType<typeof createDevice>>, TError = ErrorType<CreateDevice500>>(
 createDeviceRequestType?: BodyType<CreateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createDevice>>,
          TError,
          Awaited<ReturnType<typeof createDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateDevice<TData = Awaited<ReturnType<typeof createDevice>>, TError = ErrorType<CreateDevice500>>(
 createDeviceRequestType?: BodyType<CreateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Device
 */

export function useCreateDevice<TData = Awaited<ReturnType<typeof createDevice>>, TError = ErrorType<CreateDevice500>>(
 createDeviceRequestType?: BodyType<CreateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateDeviceQueryOptions(createDeviceRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete multiple devices

Permissions: ADMIN_DEVICES = 21
 * @summary Delete Devices
 */
export const deleteDevices = (
    deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDevicesResponseType>(
      {url: `/auth-service-v1/devices`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteDevicesRequestType, signal
    },
      options);
    }




export const getDeleteDevicesQueryKey = (deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>,) => {
    return [
    'DELETE', 'auth-service-v1','devices', deleteDevicesRequestType
    ] as const;
    }


export const getDeleteDevicesQueryOptions = <TData = Awaited<ReturnType<typeof deleteDevices>>, TError = ErrorType<DeleteDevices500>>(deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteDevicesQueryKey(deleteDevicesRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteDevices>>> = ({ signal }) => deleteDevices(deleteDevicesRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof deleteDevices>>>
export type DeleteDevicesQueryError = ErrorType<DeleteDevices500>


export function useDeleteDevices<TData = Awaited<ReturnType<typeof deleteDevices>>, TError = ErrorType<DeleteDevices500>>(
 deleteDevicesRequestType: undefined |  BodyType<DeleteDevicesRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteDevices>>,
          TError,
          Awaited<ReturnType<typeof deleteDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteDevices<TData = Awaited<ReturnType<typeof deleteDevices>>, TError = ErrorType<DeleteDevices500>>(
 deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteDevices>>,
          TError,
          Awaited<ReturnType<typeof deleteDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteDevices<TData = Awaited<ReturnType<typeof deleteDevices>>, TError = ErrorType<DeleteDevices500>>(
 deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Devices
 */

export function useDeleteDevices<TData = Awaited<ReturnType<typeof deleteDevices>>, TError = ErrorType<DeleteDevices500>>(
 deleteDevicesRequestType?: BodyType<DeleteDevicesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteDevicesQueryOptions(deleteDevicesRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all devices of current tenant

Permissions: ADMIN_DEVICES = 21 (READ)
 * @summary Find All Devices
 */
export const findAllDevices = (
    params?: FindAllDevicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDevicesResponseType>(
      {url: `/auth-service-v1/devices`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllDevicesQueryKey = (params?: FindAllDevicesParams,) => {
    return [
    'auth-service-v1','devices', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllDevicesQueryOptions = <TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(params?: FindAllDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDevices>>> = ({ signal }) => findAllDevices(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDevices>>>
export type FindAllDevicesQueryError = ErrorType<FindAllDevices500>


export function useFindAllDevices<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params: undefined |  FindAllDevicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDevices>>,
          TError,
          Awaited<ReturnType<typeof findAllDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevices<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDevices>>,
          TError,
          Awaited<ReturnType<typeof findAllDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevices<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Devices
 */

export function useFindAllDevices<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllDevicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(params?: FindAllDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDevicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDevices>>> = ({ signal }) => findAllDevices(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDevicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDevices>>>
export type FindAllDevicesSuspenseQueryError = ErrorType<FindAllDevices500>


export function useFindAllDevicesSuspense<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params: undefined |  FindAllDevicesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicesSuspense<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicesSuspense<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Devices
 */

export function useFindAllDevicesSuspense<TData = Awaited<ReturnType<typeof findAllDevices>>, TError = ErrorType<FindAllDevices500>>(
 params?: FindAllDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDevicesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Update a device

Permissions: ADMIN_DEVICES = 21 (WRITE)
 * @summary Update Device
 */
export const updateDevice = (
    id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindDeviceByIdResponseType>(
      {url: `/auth-service-v1/devices/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDeviceRequestType, signal
    },
      options);
    }




export const getUpdateDeviceQueryKey = (id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>,) => {
    return [
    'PUT', 'auth-service-v1','devices',id, updateDeviceRequestType
    ] as const;
    }


export const getUpdateDeviceQueryOptions = <TData = Awaited<ReturnType<typeof updateDevice>>, TError = ErrorType<UpdateDevice500>>(id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateDeviceQueryKey(id,updateDeviceRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateDevice>>> = ({ signal }) => updateDevice(id,updateDeviceRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdateDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof updateDevice>>>
export type UpdateDeviceQueryError = ErrorType<UpdateDevice500>


export function useUpdateDevice<TData = Awaited<ReturnType<typeof updateDevice>>, TError = ErrorType<UpdateDevice500>>(
 id: string,
    updateDeviceRequestType: undefined |  BodyType<UpdateDeviceRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateDevice>>,
          TError,
          Awaited<ReturnType<typeof updateDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateDevice<TData = Awaited<ReturnType<typeof updateDevice>>, TError = ErrorType<UpdateDevice500>>(
 id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateDevice>>,
          TError,
          Awaited<ReturnType<typeof updateDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateDevice<TData = Awaited<ReturnType<typeof updateDevice>>, TError = ErrorType<UpdateDevice500>>(
 id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update Device
 */

export function useUpdateDevice<TData = Awaited<ReturnType<typeof updateDevice>>, TError = ErrorType<UpdateDevice500>>(
 id: string,
    updateDeviceRequestType?: BodyType<UpdateDeviceRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdateDeviceQueryOptions(id,updateDeviceRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete a device

Permissions: ADMIN_DEVICES = 21
 * @summary Delete Device
 */
export const deleteDevice = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindDeviceByIdResponseType>(
      {url: `/auth-service-v1/devices/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteDeviceQueryKey = (id: string,) => {
    return [
    'DELETE', 'auth-service-v1','devices',id
    ] as const;
    }


export const getDeleteDeviceQueryOptions = <TData = Awaited<ReturnType<typeof deleteDevice>>, TError = ErrorType<DeleteDevice500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteDeviceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteDevice>>> = ({ signal }) => deleteDevice(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof deleteDevice>>>
export type DeleteDeviceQueryError = ErrorType<DeleteDevice500>


export function useDeleteDevice<TData = Awaited<ReturnType<typeof deleteDevice>>, TError = ErrorType<DeleteDevice500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteDevice>>,
          TError,
          Awaited<ReturnType<typeof deleteDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteDevice<TData = Awaited<ReturnType<typeof deleteDevice>>, TError = ErrorType<DeleteDevice500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteDevice>>,
          TError,
          Awaited<ReturnType<typeof deleteDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteDevice<TData = Awaited<ReturnType<typeof deleteDevice>>, TError = ErrorType<DeleteDevice500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Device
 */

export function useDeleteDevice<TData = Awaited<ReturnType<typeof deleteDevice>>, TError = ErrorType<DeleteDevice500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteDeviceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get a device of current tenant

Permissions: ADMIN_DEVICES = 21 (READ)
 * @summary Find Device By Id
 */
export const findDeviceById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindDeviceByIdResponseType>(
      {url: `/auth-service-v1/devices/${id}`, method: 'GET', signal
    },
      options);
    }




export const getFindDeviceByIdQueryKey = (id: string,) => {
    return [
    'auth-service-v1','devices',id
    ] as const;
    }


export const getFindDeviceByIdQueryOptions = <TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDeviceByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDeviceById>>> = ({ signal }) => findDeviceById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDeviceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findDeviceById>>>
export type FindDeviceByIdQueryError = ErrorType<FindDeviceById500>


export function useFindDeviceById<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeviceById>>,
          TError,
          Awaited<ReturnType<typeof findDeviceById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDeviceById<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findDeviceById>>,
          TError,
          Awaited<ReturnType<typeof findDeviceById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDeviceById<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Device By Id
 */

export function useFindDeviceById<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDeviceByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindDeviceByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindDeviceByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findDeviceById>>> = ({ signal }) => findDeviceById(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindDeviceByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findDeviceById>>>
export type FindDeviceByIdSuspenseQueryError = ErrorType<FindDeviceById500>


export function useFindDeviceByIdSuspense<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDeviceByIdSuspense<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindDeviceByIdSuspense<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Device By Id
 */

export function useFindDeviceByIdSuspense<TData = Awaited<ReturnType<typeof findDeviceById>>, TError = ErrorType<FindDeviceById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findDeviceById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindDeviceByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Logout a device

Permissions: ADMIN_DEVICES = 21 (WRITE)
 * @summary Logout Device
 */
export const logoutDevice = (
    id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDevicesType>(
      {url: `/auth-service-v1/devices/${id}/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emptyRequestType, signal
    },
      options);
    }




export const getLogoutDeviceQueryKey = (id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,) => {
    return [
    'POST', 'auth-service-v1','devices',id,'logout', emptyRequestType
    ] as const;
    }


export const getLogoutDeviceQueryOptions = <TData = Awaited<ReturnType<typeof logoutDevice>>, TError = ErrorType<LogoutDevice500>>(id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLogoutDeviceQueryKey(id,emptyRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logoutDevice>>> = ({ signal }) => logoutDevice(id,emptyRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LogoutDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof logoutDevice>>>
export type LogoutDeviceQueryError = ErrorType<LogoutDevice500>


export function useLogoutDevice<TData = Awaited<ReturnType<typeof logoutDevice>>, TError = ErrorType<LogoutDevice500>>(
 id: string,
    emptyRequestType: undefined |  BodyType<EmptyRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutDevice>>,
          TError,
          Awaited<ReturnType<typeof logoutDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutDevice<TData = Awaited<ReturnType<typeof logoutDevice>>, TError = ErrorType<LogoutDevice500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutDevice>>,
          TError,
          Awaited<ReturnType<typeof logoutDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutDevice<TData = Awaited<ReturnType<typeof logoutDevice>>, TError = ErrorType<LogoutDevice500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Logout Device
 */

export function useLogoutDevice<TData = Awaited<ReturnType<typeof logoutDevice>>, TError = ErrorType<LogoutDevice500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutDevice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogoutDeviceQueryOptions(id,emptyRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all websocket topics depending on the platform
 * @summary Find All Device Websocket Topics
 */
export const findAllDeviceWebsocketTopics = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDeviceWebsocketTopicsResponseType>(
      {url: `/auth-service-v1/devices/websocket-topics`, method: 'GET', signal
    },
      options);
    }




export const getFindAllDeviceWebsocketTopicsQueryKey = () => {
    return [
    'auth-service-v1','devices','websocket-topics'
    ] as const;
    }


export const getFindAllDeviceWebsocketTopicsQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDeviceWebsocketTopicsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>> = ({ signal }) => findAllDeviceWebsocketTopics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDeviceWebsocketTopicsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>>
export type FindAllDeviceWebsocketTopicsQueryError = ErrorType<FindAllDeviceWebsocketTopics500>


export function useFindAllDeviceWebsocketTopics<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>,
          TError,
          Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceWebsocketTopics<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>,
          TError,
          Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceWebsocketTopics<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Device Websocket Topics
 */

export function useFindAllDeviceWebsocketTopics<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDeviceWebsocketTopicsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllDeviceWebsocketTopicsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDeviceWebsocketTopicsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>> = ({ signal }) => findAllDeviceWebsocketTopics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDeviceWebsocketTopicsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>>
export type FindAllDeviceWebsocketTopicsSuspenseQueryError = ErrorType<FindAllDeviceWebsocketTopics500>


export function useFindAllDeviceWebsocketTopicsSuspense<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceWebsocketTopicsSuspense<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeviceWebsocketTopicsSuspense<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Device Websocket Topics
 */

export function useFindAllDeviceWebsocketTopicsSuspense<TData = Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError = ErrorType<FindAllDeviceWebsocketTopics500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeviceWebsocketTopics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDeviceWebsocketTopicsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all possible device platforms

Permissions: ADMIN_DEVICES = 21 (READ)
 * @summary Find All Device Platforms
 */
export const findAllDevicePlatforms = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllDevicePlatformsResponseType>(
      {url: `/auth-service-v1/devices/platforms`, method: 'GET', signal
    },
      options);
    }




export const getFindAllDevicePlatformsQueryKey = () => {
    return [
    'auth-service-v1','devices','platforms'
    ] as const;
    }


export const getFindAllDevicePlatformsQueryOptions = <TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDevicePlatformsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDevicePlatforms>>> = ({ signal }) => findAllDevicePlatforms(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDevicePlatformsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDevicePlatforms>>>
export type FindAllDevicePlatformsQueryError = ErrorType<FindAllDevicePlatforms500>


export function useFindAllDevicePlatforms<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDevicePlatforms>>,
          TError,
          Awaited<ReturnType<typeof findAllDevicePlatforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicePlatforms<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDevicePlatforms>>,
          TError,
          Awaited<ReturnType<typeof findAllDevicePlatforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicePlatforms<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Device Platforms
 */

export function useFindAllDevicePlatforms<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDevicePlatformsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllDevicePlatformsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDevicePlatformsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDevicePlatforms>>> = ({ signal }) => findAllDevicePlatforms(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDevicePlatformsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDevicePlatforms>>>
export type FindAllDevicePlatformsSuspenseQueryError = ErrorType<FindAllDevicePlatforms500>


export function useFindAllDevicePlatformsSuspense<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicePlatformsSuspense<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDevicePlatformsSuspense<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Device Platforms
 */

export function useFindAllDevicePlatformsSuspense<TData = Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError = ErrorType<FindAllDevicePlatforms500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDevicePlatforms>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDevicePlatformsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create a group

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Create Group
 */
export const createGroup = (
    createGroupRequestType?: BodyType<CreateGroupRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindGroupByIdResponseType>(
      {url: `/auth-service-v1/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupRequestType, signal
    },
      options);
    }




export const getCreateGroupQueryKey = (createGroupRequestType?: BodyType<CreateGroupRequestType>,) => {
    return [
    'POST', 'auth-service-v1','groups', createGroupRequestType
    ] as const;
    }


export const getCreateGroupQueryOptions = <TData = Awaited<ReturnType<typeof createGroup>>, TError = ErrorType<CreateGroup500>>(createGroupRequestType?: BodyType<CreateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateGroupQueryKey(createGroupRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createGroup>>> = ({ signal }) => createGroup(createGroupRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateGroupQueryResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
export type CreateGroupQueryError = ErrorType<CreateGroup500>


export function useCreateGroup<TData = Awaited<ReturnType<typeof createGroup>>, TError = ErrorType<CreateGroup500>>(
 createGroupRequestType: undefined |  BodyType<CreateGroupRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createGroup>>,
          TError,
          Awaited<ReturnType<typeof createGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateGroup<TData = Awaited<ReturnType<typeof createGroup>>, TError = ErrorType<CreateGroup500>>(
 createGroupRequestType?: BodyType<CreateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createGroup>>,
          TError,
          Awaited<ReturnType<typeof createGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateGroup<TData = Awaited<ReturnType<typeof createGroup>>, TError = ErrorType<CreateGroup500>>(
 createGroupRequestType?: BodyType<CreateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Group
 */

export function useCreateGroup<TData = Awaited<ReturnType<typeof createGroup>>, TError = ErrorType<CreateGroup500>>(
 createGroupRequestType?: BodyType<CreateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateGroupQueryOptions(createGroupRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all groups

Permissions: ADMIN_GROUPS = 1 (READ)
 * @summary Find All Groups
 */
export const findAllGroups = (
    params?: FindAllGroupsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupsResponseType>(
      {url: `/auth-service-v1/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllGroupsQueryKey = (params?: FindAllGroupsParams,) => {
    return [
    'auth-service-v1','groups', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllGroupsQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(params?: FindAllGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroups>>> = ({ signal }) => findAllGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroups>>>
export type FindAllGroupsQueryError = ErrorType<FindAllGroups500>


export function useFindAllGroups<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params: undefined |  FindAllGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroups>>,
          TError,
          Awaited<ReturnType<typeof findAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroups<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroups>>,
          TError,
          Awaited<ReturnType<typeof findAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroups<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Groups
 */

export function useFindAllGroups<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(params?: FindAllGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroups>>> = ({ signal }) => findAllGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroups>>>
export type FindAllGroupsSuspenseQueryError = ErrorType<FindAllGroups500>


export function useFindAllGroupsSuspense<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params: undefined |  FindAllGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupsSuspense<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupsSuspense<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Groups
 */

export function useFindAllGroupsSuspense<TData = Awaited<ReturnType<typeof findAllGroups>>, TError = ErrorType<FindAllGroups500>>(
 params?: FindAllGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Update a group

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Update Group
 */
export const updateGroup = (
    id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindGroupByIdResponseType>(
      {url: `/auth-service-v1/groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupRequestType, signal
    },
      options);
    }




export const getUpdateGroupQueryKey = (id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>,) => {
    return [
    'PUT', 'auth-service-v1','groups',id, updateGroupRequestType
    ] as const;
    }


export const getUpdateGroupQueryOptions = <TData = Awaited<ReturnType<typeof updateGroup>>, TError = ErrorType<UpdateGroup500>>(id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateGroupQueryKey(id,updateGroupRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateGroup>>> = ({ signal }) => updateGroup(id,updateGroupRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdateGroupQueryResult = NonNullable<Awaited<ReturnType<typeof updateGroup>>>
export type UpdateGroupQueryError = ErrorType<UpdateGroup500>


export function useUpdateGroup<TData = Awaited<ReturnType<typeof updateGroup>>, TError = ErrorType<UpdateGroup500>>(
 id: string,
    updateGroupRequestType: undefined |  BodyType<UpdateGroupRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateGroup>>,
          TError,
          Awaited<ReturnType<typeof updateGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateGroup<TData = Awaited<ReturnType<typeof updateGroup>>, TError = ErrorType<UpdateGroup500>>(
 id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateGroup>>,
          TError,
          Awaited<ReturnType<typeof updateGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateGroup<TData = Awaited<ReturnType<typeof updateGroup>>, TError = ErrorType<UpdateGroup500>>(
 id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update Group
 */

export function useUpdateGroup<TData = Awaited<ReturnType<typeof updateGroup>>, TError = ErrorType<UpdateGroup500>>(
 id: string,
    updateGroupRequestType?: BodyType<UpdateGroupRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdateGroupQueryOptions(id,updateGroupRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete a group

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Delete Group
 */
export const deleteGroup = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindGroupByIdResponseType>(
      {url: `/auth-service-v1/groups/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteGroupQueryKey = (id: string,) => {
    return [
    'DELETE', 'auth-service-v1','groups',id
    ] as const;
    }


export const getDeleteGroupQueryOptions = <TData = Awaited<ReturnType<typeof deleteGroup>>, TError = ErrorType<DeleteGroup500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteGroup>>> = ({ signal }) => deleteGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteGroupQueryResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>
export type DeleteGroupQueryError = ErrorType<DeleteGroup500>


export function useDeleteGroup<TData = Awaited<ReturnType<typeof deleteGroup>>, TError = ErrorType<DeleteGroup500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteGroup>>,
          TError,
          Awaited<ReturnType<typeof deleteGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteGroup<TData = Awaited<ReturnType<typeof deleteGroup>>, TError = ErrorType<DeleteGroup500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteGroup>>,
          TError,
          Awaited<ReturnType<typeof deleteGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteGroup<TData = Awaited<ReturnType<typeof deleteGroup>>, TError = ErrorType<DeleteGroup500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Group
 */

export function useDeleteGroup<TData = Awaited<ReturnType<typeof deleteGroup>>, TError = ErrorType<DeleteGroup500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find Group By Id

Permissions: ADMIN_GROUPS = 1 (READ)
 * @summary Find Group By Id
 */
export const findGroupById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindGroupByIdResponseType>(
      {url: `/auth-service-v1/groups/${id}`, method: 'GET', signal
    },
      options);
    }




export const getFindGroupByIdQueryKey = (id: string,) => {
    return [
    'auth-service-v1','groups',id
    ] as const;
    }


export const getFindGroupByIdQueryOptions = <TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindGroupByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findGroupById>>> = ({ signal }) => findGroupById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindGroupByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findGroupById>>>
export type FindGroupByIdQueryError = ErrorType<FindGroupById500>


export function useFindGroupById<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGroupById>>,
          TError,
          Awaited<ReturnType<typeof findGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroupById<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGroupById>>,
          TError,
          Awaited<ReturnType<typeof findGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroupById<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Group By Id
 */

export function useFindGroupById<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindGroupByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindGroupByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindGroupByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findGroupById>>> = ({ signal }) => findGroupById(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindGroupByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findGroupById>>>
export type FindGroupByIdSuspenseQueryError = ErrorType<FindGroupById500>


export function useFindGroupByIdSuspense<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroupByIdSuspense<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGroupByIdSuspense<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Group By Id
 */

export function useFindGroupByIdSuspense<TData = Awaited<ReturnType<typeof findGroupById>>, TError = ErrorType<FindGroupById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGroupById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindGroupByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all users of group

Permissions: ADMIN_GROUPS = 1 (READ)
 * @summary Find All Group Users
 */
export const findAllGroupUsers = (
    id: string,
    params?: FindAllGroupUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupUsersResponseType>(
      {url: `/auth-service-v1/groups/${id}/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllGroupUsersQueryKey = (id: string,
    params?: FindAllGroupUsersParams,) => {
    return [
    'auth-service-v1','groups',id,'users', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllGroupUsersQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupUsersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroupUsers>>> = ({ signal }) => findAllGroupUsers(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupUsersQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroupUsers>>>
export type FindAllGroupUsersQueryError = ErrorType<FindAllGroupUsers500>


export function useFindAllGroupUsers<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params: undefined |  FindAllGroupUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof findAllGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupUsers<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof findAllGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupUsers<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Group Users
 */

export function useFindAllGroupUsers<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupUsersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllGroupUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupUsersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroupUsers>>> = ({ signal }) => findAllGroupUsers(id,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroupUsers>>>
export type FindAllGroupUsersSuspenseQueryError = ErrorType<FindAllGroupUsers500>


export function useFindAllGroupUsersSuspense<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params: undefined |  FindAllGroupUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupUsersSuspense<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupUsersSuspense<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Group Users
 */

export function useFindAllGroupUsersSuspense<TData = Awaited<ReturnType<typeof findAllGroupUsers>>, TError = ErrorType<FindAllGroupUsers500>>(
 id: string,
    params?: FindAllGroupUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupUsersSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create Users of Group. Old Users are not deleted, only new ones are added

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Create Group Users
 */
export const saveGroupUsers = (
    id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupUsersResponseType>(
      {url: `/auth-service-v1/groups/${id}/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupUsersRequestType, signal
    },
      options);
    }




export const getSaveGroupUsersQueryKey = (id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>,) => {
    return [
    'POST', 'auth-service-v1','groups',id,'users', createGroupUsersRequestType
    ] as const;
    }


export const getSaveGroupUsersQueryOptions = <TData = Awaited<ReturnType<typeof saveGroupUsers>>, TError = ErrorType<SaveGroupUsers500>>(id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveGroupUsersQueryKey(id,createGroupUsersRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveGroupUsers>>> = ({ signal }) => saveGroupUsers(id,createGroupUsersRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveGroupUsersQueryResult = NonNullable<Awaited<ReturnType<typeof saveGroupUsers>>>
export type SaveGroupUsersQueryError = ErrorType<SaveGroupUsers500>


export function useSaveGroupUsers<TData = Awaited<ReturnType<typeof saveGroupUsers>>, TError = ErrorType<SaveGroupUsers500>>(
 id: string,
    createGroupUsersRequestType: undefined |  BodyType<CreateGroupUsersRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof saveGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveGroupUsers<TData = Awaited<ReturnType<typeof saveGroupUsers>>, TError = ErrorType<SaveGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof saveGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveGroupUsers<TData = Awaited<ReturnType<typeof saveGroupUsers>>, TError = ErrorType<SaveGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Group Users
 */

export function useSaveGroupUsers<TData = Awaited<ReturnType<typeof saveGroupUsers>>, TError = ErrorType<SaveGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveGroupUsersQueryOptions(id,createGroupUsersRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete Users of Group

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Remove Group Users
 */
export const deleteGroupUsers = (
    id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupUsersResponseType>(
      {url: `/auth-service-v1/groups/${id}/users`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: createGroupUsersRequestType, signal
    },
      options);
    }




export const getDeleteGroupUsersQueryKey = (id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>,) => {
    return [
    'DELETE', 'auth-service-v1','groups',id,'users', createGroupUsersRequestType
    ] as const;
    }


export const getDeleteGroupUsersQueryOptions = <TData = Awaited<ReturnType<typeof deleteGroupUsers>>, TError = ErrorType<DeleteGroupUsers500>>(id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteGroupUsersQueryKey(id,createGroupUsersRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteGroupUsers>>> = ({ signal }) => deleteGroupUsers(id,createGroupUsersRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteGroupUsersQueryResult = NonNullable<Awaited<ReturnType<typeof deleteGroupUsers>>>
export type DeleteGroupUsersQueryError = ErrorType<DeleteGroupUsers500>


export function useDeleteGroupUsers<TData = Awaited<ReturnType<typeof deleteGroupUsers>>, TError = ErrorType<DeleteGroupUsers500>>(
 id: string,
    createGroupUsersRequestType: undefined |  BodyType<CreateGroupUsersRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof deleteGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteGroupUsers<TData = Awaited<ReturnType<typeof deleteGroupUsers>>, TError = ErrorType<DeleteGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteGroupUsers>>,
          TError,
          Awaited<ReturnType<typeof deleteGroupUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteGroupUsers<TData = Awaited<ReturnType<typeof deleteGroupUsers>>, TError = ErrorType<DeleteGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove Group Users
 */

export function useDeleteGroupUsers<TData = Awaited<ReturnType<typeof deleteGroupUsers>>, TError = ErrorType<DeleteGroupUsers500>>(
 id: string,
    createGroupUsersRequestType?: BodyType<CreateGroupUsersRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteGroupUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteGroupUsersQueryOptions(id,createGroupUsersRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all permissions of group
Filtered by the permissions that are possible by the tenant-modules
 * @summary Find All Group Permissions
 */
export const findAllGroupPermissions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupPermissionsResponseType>(
      {url: `/auth-service-v1/groups/${id}/permissions`, method: 'GET', signal
    },
      options);
    }




export const getFindAllGroupPermissionsQueryKey = (id: string,) => {
    return [
    'auth-service-v1','groups',id,'permissions'
    ] as const;
    }


export const getFindAllGroupPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupPermissionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroupPermissions>>> = ({ signal }) => findAllGroupPermissions(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroupPermissions>>>
export type FindAllGroupPermissionsQueryError = ErrorType<FindAllGroupPermissions500>


export function useFindAllGroupPermissions<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupPermissions<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupPermissions<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Group Permissions
 */

export function useFindAllGroupPermissions<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupPermissionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllGroupPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllGroupPermissionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllGroupPermissions>>> = ({ signal }) => findAllGroupPermissions(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllGroupPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllGroupPermissions>>>
export type FindAllGroupPermissionsSuspenseQueryError = ErrorType<FindAllGroupPermissions500>


export function useFindAllGroupPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllGroupPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Group Permissions
 */

export function useFindAllGroupPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllGroupPermissions>>, TError = ErrorType<FindAllGroupPermissions500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllGroupPermissionsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Save Permissions of Group (deletes the old ones). Returns all permissions, not only the changed ones.

Permissions: ADMIN_GROUPS = 1 (WRITE)
 * @summary Save Group Permissions
 */
export const saveGroupPermissions = (
    id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllGroupPermissionsResponseType>(
      {url: `/auth-service-v1/groups/${id}/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveGroupPermissionsRequestType, signal
    },
      options);
    }




export const getSaveGroupPermissionsQueryKey = (id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>,) => {
    return [
    'POST', 'auth-service-v1','groups',id,'permissions', saveGroupPermissionsRequestType
    ] as const;
    }


export const getSaveGroupPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof saveGroupPermissions>>, TError = ErrorType<SaveGroupPermissions500>>(id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveGroupPermissionsQueryKey(id,saveGroupPermissionsRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveGroupPermissions>>> = ({ signal }) => saveGroupPermissions(id,saveGroupPermissionsRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveGroupPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof saveGroupPermissions>>>
export type SaveGroupPermissionsQueryError = ErrorType<SaveGroupPermissions500>


export function useSaveGroupPermissions<TData = Awaited<ReturnType<typeof saveGroupPermissions>>, TError = ErrorType<SaveGroupPermissions500>>(
 id: string,
    saveGroupPermissionsRequestType: undefined |  BodyType<SaveGroupPermissionsRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof saveGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveGroupPermissions<TData = Awaited<ReturnType<typeof saveGroupPermissions>>, TError = ErrorType<SaveGroupPermissions500>>(
 id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveGroupPermissions>>,
          TError,
          Awaited<ReturnType<typeof saveGroupPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveGroupPermissions<TData = Awaited<ReturnType<typeof saveGroupPermissions>>, TError = ErrorType<SaveGroupPermissions500>>(
 id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Save Group Permissions
 */

export function useSaveGroupPermissions<TData = Awaited<ReturnType<typeof saveGroupPermissions>>, TError = ErrorType<SaveGroupPermissions500>>(
 id: string,
    saveGroupPermissionsRequestType?: BodyType<SaveGroupPermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveGroupPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveGroupPermissionsQueryOptions(id,saveGroupPermissionsRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Gets all active sessions of the own user
 * @summary Find own Active Sessions
 */
export const findOwnActiveSessions = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindOwnActiveSessionsResponseType>(
      {url: `/auth-service-v1/me/sessions`, method: 'GET', signal
    },
      options);
    }




export const getFindOwnActiveSessionsQueryKey = () => {
    return [
    'auth-service-v1','me','sessions'
    ] as const;
    }


export const getFindOwnActiveSessionsQueryOptions = <TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnActiveSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnActiveSessions>>> = ({ signal }) => findOwnActiveSessions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnActiveSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnActiveSessions>>>
export type FindOwnActiveSessionsQueryError = ErrorType<FindOwnActiveSessions500>


export function useFindOwnActiveSessions<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnActiveSessions>>,
          TError,
          Awaited<ReturnType<typeof findOwnActiveSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnActiveSessions<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnActiveSessions>>,
          TError,
          Awaited<ReturnType<typeof findOwnActiveSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnActiveSessions<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own Active Sessions
 */

export function useFindOwnActiveSessions<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnActiveSessionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindOwnActiveSessionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnActiveSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnActiveSessions>>> = ({ signal }) => findOwnActiveSessions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnActiveSessionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnActiveSessions>>>
export type FindOwnActiveSessionsSuspenseQueryError = ErrorType<FindOwnActiveSessions500>


export function useFindOwnActiveSessionsSuspense<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnActiveSessionsSuspense<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnActiveSessionsSuspense<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own Active Sessions
 */

export function useFindOwnActiveSessionsSuspense<TData = Awaited<ReturnType<typeof findOwnActiveSessions>>, TError = ErrorType<FindOwnActiveSessions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnActiveSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnActiveSessionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Invalidates an own user session. After this the refreshtoken saved on the client wont work any longer.
 * @summary Invalidate own User Session
 */
export const invalidateSessionOfOwnUser = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/me/sessions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getInvalidateSessionOfOwnUserQueryKey = (id: string,) => {
    return [
    'DELETE', 'auth-service-v1','me','sessions',id
    ] as const;
    }


export const getInvalidateSessionOfOwnUserQueryOptions = <TData = Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError = ErrorType<InvalidateSessionOfOwnUser500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvalidateSessionOfOwnUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>> = ({ signal }) => invalidateSessionOfOwnUser(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvalidateSessionOfOwnUserQueryResult = NonNullable<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>>
export type InvalidateSessionOfOwnUserQueryError = ErrorType<InvalidateSessionOfOwnUser500>


export function useInvalidateSessionOfOwnUser<TData = Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError = ErrorType<InvalidateSessionOfOwnUser500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>,
          TError,
          Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvalidateSessionOfOwnUser<TData = Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError = ErrorType<InvalidateSessionOfOwnUser500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>,
          TError,
          Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvalidateSessionOfOwnUser<TData = Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError = ErrorType<InvalidateSessionOfOwnUser500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invalidate own User Session
 */

export function useInvalidateSessionOfOwnUser<TData = Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError = ErrorType<InvalidateSessionOfOwnUser500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateSessionOfOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvalidateSessionOfOwnUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Invalidates own user session. After this the refreshtoken saved on the client wont work any longer.
 * @summary Logout
 */
export const logoutMe = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/me/logout`, method: 'POST', signal
    },
      options);
    }




export const getLogoutMeQueryKey = () => {
    return [
    'POST', 'auth-service-v1','me','logout'
    ] as const;
    }


export const getLogoutMeQueryOptions = <TData = Awaited<ReturnType<typeof logoutMe>>, TError = ErrorType<LogoutMe500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLogoutMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logoutMe>>> = ({ signal }) => logoutMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LogoutMeQueryResult = NonNullable<Awaited<ReturnType<typeof logoutMe>>>
export type LogoutMeQueryError = ErrorType<LogoutMe500>


export function useLogoutMe<TData = Awaited<ReturnType<typeof logoutMe>>, TError = ErrorType<LogoutMe500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutMe>>,
          TError,
          Awaited<ReturnType<typeof logoutMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutMe<TData = Awaited<ReturnType<typeof logoutMe>>, TError = ErrorType<LogoutMe500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutMe>>,
          TError,
          Awaited<ReturnType<typeof logoutMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutMe<TData = Awaited<ReturnType<typeof logoutMe>>, TError = ErrorType<LogoutMe500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Logout
 */

export function useLogoutMe<TData = Awaited<ReturnType<typeof logoutMe>>, TError = ErrorType<LogoutMe500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogoutMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find Own Tenants
 * @summary Find own Tenants
 */
export const findOwnTenants = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindOwnTenantsResponseType>(
      {url: `/auth-service-v1/me/tenants`, method: 'GET', signal
    },
      options);
    }




export const getFindOwnTenantsQueryKey = () => {
    return [
    'auth-service-v1','me','tenants'
    ] as const;
    }


export const getFindOwnTenantsQueryOptions = <TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnTenants>>> = ({ signal }) => findOwnTenants(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnTenants>>>
export type FindOwnTenantsQueryError = ErrorType<FindOwnTenants500>


export function useFindOwnTenants<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnTenants>>,
          TError,
          Awaited<ReturnType<typeof findOwnTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnTenants<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnTenants>>,
          TError,
          Awaited<ReturnType<typeof findOwnTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnTenants<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own Tenants
 */

export function useFindOwnTenants<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnTenantsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindOwnTenantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnTenants>>> = ({ signal }) => findOwnTenants(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnTenantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnTenants>>>
export type FindOwnTenantsSuspenseQueryError = ErrorType<FindOwnTenants500>


export function useFindOwnTenantsSuspense<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnTenantsSuspense<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnTenantsSuspense<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own Tenants
 */

export function useFindOwnTenantsSuspense<TData = Awaited<ReturnType<typeof findOwnTenants>>, TError = ErrorType<FindOwnTenants500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnTenantsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find own User
 * @summary Find own User
 */
export const findOwnUser = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindUserByIdResponseType>(
      {url: `/auth-service-v1/me/users/me`, method: 'GET', signal
    },
      options);
    }




export const getFindOwnUserQueryKey = () => {
    return [
    'auth-service-v1','me','users','me'
    ] as const;
    }


export const getFindOwnUserQueryOptions = <TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnUser>>> = ({ signal }) => findOwnUser(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnUserQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnUser>>>
export type FindOwnUserQueryError = ErrorType<FindOwnUser500>


export function useFindOwnUser<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnUser>>,
          TError,
          Awaited<ReturnType<typeof findOwnUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnUser<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnUser>>,
          TError,
          Awaited<ReturnType<typeof findOwnUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnUser<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own User
 */

export function useFindOwnUser<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindOwnUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnUser>>> = ({ signal }) => findOwnUser(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnUser>>>
export type FindOwnUserSuspenseQueryError = ErrorType<FindOwnUser500>


export function useFindOwnUserSuspense<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnUserSuspense<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnUserSuspense<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own User
 */

export function useFindOwnUserSuspense<TData = Awaited<ReturnType<typeof findOwnUser>>, TError = ErrorType<FindOwnUser500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all own permissions that are possible according the tenant-modules and user-groups
 * @summary Find own permissions
 */
export const findOwnPermissions = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserPermissionsResponseType>(
      {url: `/auth-service-v1/me/permissions`, method: 'GET', signal
    },
      options);
    }




export const getFindOwnPermissionsQueryKey = () => {
    return [
    'auth-service-v1','me','permissions'
    ] as const;
    }


export const getFindOwnPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnPermissions>>> = ({ signal }) => findOwnPermissions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnPermissions>>>
export type FindOwnPermissionsQueryError = ErrorType<FindOwnPermissions500>


export function useFindOwnPermissions<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnPermissions>>,
          TError,
          Awaited<ReturnType<typeof findOwnPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnPermissions<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findOwnPermissions>>,
          TError,
          Awaited<ReturnType<typeof findOwnPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnPermissions<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own permissions
 */

export function useFindOwnPermissions<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindOwnPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindOwnPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findOwnPermissions>>> = ({ signal }) => findOwnPermissions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindOwnPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findOwnPermissions>>>
export type FindOwnPermissionsSuspenseQueryError = ErrorType<FindOwnPermissions500>


export function useFindOwnPermissionsSuspense<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnPermissionsSuspense<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindOwnPermissionsSuspense<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find own permissions
 */

export function useFindOwnPermissionsSuspense<TData = Awaited<ReturnType<typeof findOwnPermissions>>, TError = ErrorType<FindOwnPermissions500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findOwnPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindOwnPermissionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Reconfirm the password for dangerous actions
 * @summary Reconfirm Password
 */
export const reconfirmPasswordMe = (
    reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/me/reconfirm-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reconfirmPasswordUserRequestType, signal
    },
      options);
    }




export const getReconfirmPasswordMeQueryKey = (reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','me','reconfirm-password', reconfirmPasswordUserRequestType
    ] as const;
    }


export const getReconfirmPasswordMeQueryOptions = <TData = Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError = ErrorType<ReconfirmPasswordMe500>>(reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconfirmPasswordMeQueryKey(reconfirmPasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconfirmPasswordMe>>> = ({ signal }) => reconfirmPasswordMe(reconfirmPasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconfirmPasswordMeQueryResult = NonNullable<Awaited<ReturnType<typeof reconfirmPasswordMe>>>
export type ReconfirmPasswordMeQueryError = ErrorType<ReconfirmPasswordMe500>


export function useReconfirmPasswordMe<TData = Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError = ErrorType<ReconfirmPasswordMe500>>(
 reconfirmPasswordUserRequestType: undefined |  BodyType<ReconfirmPasswordUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconfirmPasswordMe>>,
          TError,
          Awaited<ReturnType<typeof reconfirmPasswordMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconfirmPasswordMe<TData = Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError = ErrorType<ReconfirmPasswordMe500>>(
 reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconfirmPasswordMe>>,
          TError,
          Awaited<ReturnType<typeof reconfirmPasswordMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconfirmPasswordMe<TData = Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError = ErrorType<ReconfirmPasswordMe500>>(
 reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reconfirm Password
 */

export function useReconfirmPasswordMe<TData = Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError = ErrorType<ReconfirmPasswordMe500>>(
 reconfirmPasswordUserRequestType?: BodyType<ReconfirmPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconfirmPasswordMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconfirmPasswordMeQueryOptions(reconfirmPasswordUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create a module (only for CONSOLE)
 * @summary Create Module
 */
export const createModule = (
    createModuleRequestType?: BodyType<CreateModuleRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindModuleByIdResponseType>(
      {url: `/auth-service-v1/modules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createModuleRequestType, signal
    },
      options);
    }




export const getCreateModuleQueryKey = (createModuleRequestType?: BodyType<CreateModuleRequestType>,) => {
    return [
    'POST', 'auth-service-v1','modules', createModuleRequestType
    ] as const;
    }


export const getCreateModuleQueryOptions = <TData = Awaited<ReturnType<typeof createModule>>, TError = ErrorType<CreateModule500>>(createModuleRequestType?: BodyType<CreateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateModuleQueryKey(createModuleRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createModule>>> = ({ signal }) => createModule(createModuleRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateModuleQueryResult = NonNullable<Awaited<ReturnType<typeof createModule>>>
export type CreateModuleQueryError = ErrorType<CreateModule500>


export function useCreateModule<TData = Awaited<ReturnType<typeof createModule>>, TError = ErrorType<CreateModule500>>(
 createModuleRequestType: undefined |  BodyType<CreateModuleRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createModule>>,
          TError,
          Awaited<ReturnType<typeof createModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateModule<TData = Awaited<ReturnType<typeof createModule>>, TError = ErrorType<CreateModule500>>(
 createModuleRequestType?: BodyType<CreateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createModule>>,
          TError,
          Awaited<ReturnType<typeof createModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateModule<TData = Awaited<ReturnType<typeof createModule>>, TError = ErrorType<CreateModule500>>(
 createModuleRequestType?: BodyType<CreateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Module
 */

export function useCreateModule<TData = Awaited<ReturnType<typeof createModule>>, TError = ErrorType<CreateModule500>>(
 createModuleRequestType?: BodyType<CreateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateModuleQueryOptions(createModuleRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all modules (only for CONSOLE)
 * @summary Find All Modules
 */
export const findAllModules = (
    params?: FindAllModulesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllModulesResponseType>(
      {url: `/auth-service-v1/modules`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllModulesQueryKey = (params?: FindAllModulesParams,) => {
    return [
    'auth-service-v1','modules', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllModulesQueryOptions = <TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(params?: FindAllModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModules>>> = ({ signal }) => findAllModules(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModulesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModules>>>
export type FindAllModulesQueryError = ErrorType<FindAllModules500>


export function useFindAllModules<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params: undefined |  FindAllModulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModules>>,
          TError,
          Awaited<ReturnType<typeof findAllModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModules<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModules>>,
          TError,
          Awaited<ReturnType<typeof findAllModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModules<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Modules
 */

export function useFindAllModules<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllModulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(params?: FindAllModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModules>>> = ({ signal }) => findAllModules(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModules>>>
export type FindAllModulesSuspenseQueryError = ErrorType<FindAllModules500>


export function useFindAllModulesSuspense<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params: undefined |  FindAllModulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulesSuspense<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulesSuspense<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Modules
 */

export function useFindAllModulesSuspense<TData = Awaited<ReturnType<typeof findAllModules>>, TError = ErrorType<FindAllModules500>>(
 params?: FindAllModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Update a module (only for CONSOLE)
 * @summary Update Module
 */
export const updateModule = (
    id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindModuleByIdResponseType>(
      {url: `/auth-service-v1/modules/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateModuleRequestType, signal
    },
      options);
    }




export const getUpdateModuleQueryKey = (id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>,) => {
    return [
    'PUT', 'auth-service-v1','modules',id, updateModuleRequestType
    ] as const;
    }


export const getUpdateModuleQueryOptions = <TData = Awaited<ReturnType<typeof updateModule>>, TError = ErrorType<UpdateModule500>>(id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateModuleQueryKey(id,updateModuleRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateModule>>> = ({ signal }) => updateModule(id,updateModuleRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdateModuleQueryResult = NonNullable<Awaited<ReturnType<typeof updateModule>>>
export type UpdateModuleQueryError = ErrorType<UpdateModule500>


export function useUpdateModule<TData = Awaited<ReturnType<typeof updateModule>>, TError = ErrorType<UpdateModule500>>(
 id: string,
    updateModuleRequestType: undefined |  BodyType<UpdateModuleRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateModule>>,
          TError,
          Awaited<ReturnType<typeof updateModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateModule<TData = Awaited<ReturnType<typeof updateModule>>, TError = ErrorType<UpdateModule500>>(
 id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateModule>>,
          TError,
          Awaited<ReturnType<typeof updateModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateModule<TData = Awaited<ReturnType<typeof updateModule>>, TError = ErrorType<UpdateModule500>>(
 id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update Module
 */

export function useUpdateModule<TData = Awaited<ReturnType<typeof updateModule>>, TError = ErrorType<UpdateModule500>>(
 id: string,
    updateModuleRequestType?: BodyType<UpdateModuleRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdateModuleQueryOptions(id,updateModuleRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete a module (only for CONSOLE)
 * @summary Delete Module
 */
export const deleteModule = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindModuleByIdResponseType>(
      {url: `/auth-service-v1/modules/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteModuleQueryKey = (id: string,) => {
    return [
    'DELETE', 'auth-service-v1','modules',id
    ] as const;
    }


export const getDeleteModuleQueryOptions = <TData = Awaited<ReturnType<typeof deleteModule>>, TError = ErrorType<DeleteModule500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteModuleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteModule>>> = ({ signal }) => deleteModule(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteModuleQueryResult = NonNullable<Awaited<ReturnType<typeof deleteModule>>>
export type DeleteModuleQueryError = ErrorType<DeleteModule500>


export function useDeleteModule<TData = Awaited<ReturnType<typeof deleteModule>>, TError = ErrorType<DeleteModule500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteModule>>,
          TError,
          Awaited<ReturnType<typeof deleteModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteModule<TData = Awaited<ReturnType<typeof deleteModule>>, TError = ErrorType<DeleteModule500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteModule>>,
          TError,
          Awaited<ReturnType<typeof deleteModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteModule<TData = Awaited<ReturnType<typeof deleteModule>>, TError = ErrorType<DeleteModule500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Module
 */

export function useDeleteModule<TData = Awaited<ReturnType<typeof deleteModule>>, TError = ErrorType<DeleteModule500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteModuleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find Moduly By Id (only for CONSOLE)
 * @summary Find Module By Id
 */
export const findModuleById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindModuleByIdResponseType>(
      {url: `/auth-service-v1/modules/${id}`, method: 'GET', signal
    },
      options);
    }




export const getFindModuleByIdQueryKey = (id: string,) => {
    return [
    'auth-service-v1','modules',id
    ] as const;
    }


export const getFindModuleByIdQueryOptions = <TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindModuleByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findModuleById>>> = ({ signal }) => findModuleById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindModuleByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findModuleById>>>
export type FindModuleByIdQueryError = ErrorType<FindModuleById500>


export function useFindModuleById<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findModuleById>>,
          TError,
          Awaited<ReturnType<typeof findModuleById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindModuleById<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findModuleById>>,
          TError,
          Awaited<ReturnType<typeof findModuleById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindModuleById<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Module By Id
 */

export function useFindModuleById<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindModuleByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindModuleByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindModuleByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findModuleById>>> = ({ signal }) => findModuleById(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindModuleByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findModuleById>>>
export type FindModuleByIdSuspenseQueryError = ErrorType<FindModuleById500>


export function useFindModuleByIdSuspense<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindModuleByIdSuspense<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindModuleByIdSuspense<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Module By Id
 */

export function useFindModuleByIdSuspense<TData = Awaited<ReturnType<typeof findModuleById>>, TError = ErrorType<FindModuleById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findModuleById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindModuleByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all tenants of module (only for CONSOLE)
 * @summary Find All Module Tenants
 */
export const findAllModuleTenants = (
    id: string,
    params?: FindAllModuleTenantsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllModuleTenantsResponseType>(
      {url: `/auth-service-v1/modules/${id}/tenants`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllModuleTenantsQueryKey = (id: string,
    params?: FindAllModuleTenantsParams,) => {
    return [
    'auth-service-v1','modules',id,'tenants', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllModuleTenantsQueryOptions = <TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModuleTenantsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModuleTenants>>> = ({ signal }) => findAllModuleTenants(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModuleTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModuleTenants>>>
export type FindAllModuleTenantsQueryError = ErrorType<FindAllModuleTenants500>


export function useFindAllModuleTenants<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params: undefined |  FindAllModuleTenantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModuleTenants>>,
          TError,
          Awaited<ReturnType<typeof findAllModuleTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModuleTenants<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModuleTenants>>,
          TError,
          Awaited<ReturnType<typeof findAllModuleTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModuleTenants<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Module Tenants
 */

export function useFindAllModuleTenants<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModuleTenantsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllModuleTenantsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModuleTenantsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModuleTenants>>> = ({ signal }) => findAllModuleTenants(id,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModuleTenantsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModuleTenants>>>
export type FindAllModuleTenantsSuspenseQueryError = ErrorType<FindAllModuleTenants500>


export function useFindAllModuleTenantsSuspense<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params: undefined |  FindAllModuleTenantsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModuleTenantsSuspense<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModuleTenantsSuspense<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Module Tenants
 */

export function useFindAllModuleTenantsSuspense<TData = Awaited<ReturnType<typeof findAllModuleTenants>>, TError = ErrorType<FindAllModuleTenants500>>(
 id: string,
    params?: FindAllModuleTenantsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModuleTenantsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Save Tenants of Module (only for CONSOLE)
 * @summary Save Module Tenants
 */
export const saveModuleTenants = (
    id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllModuleTenantsResponseType>(
      {url: `/auth-service-v1/modules/${id}/tenants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveModuleTenantsRequestType, signal
    },
      options);
    }




export const getSaveModuleTenantsQueryKey = (id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>,) => {
    return [
    'POST', 'auth-service-v1','modules',id,'tenants', saveModuleTenantsRequestType
    ] as const;
    }


export const getSaveModuleTenantsQueryOptions = <TData = Awaited<ReturnType<typeof saveModuleTenants>>, TError = ErrorType<SaveModuleTenants500>>(id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveModuleTenantsQueryKey(id,saveModuleTenantsRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveModuleTenants>>> = ({ signal }) => saveModuleTenants(id,saveModuleTenantsRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveModuleTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof saveModuleTenants>>>
export type SaveModuleTenantsQueryError = ErrorType<SaveModuleTenants500>


export function useSaveModuleTenants<TData = Awaited<ReturnType<typeof saveModuleTenants>>, TError = ErrorType<SaveModuleTenants500>>(
 id: string,
    saveModuleTenantsRequestType: undefined |  BodyType<SaveModuleTenantsRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveModuleTenants>>,
          TError,
          Awaited<ReturnType<typeof saveModuleTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveModuleTenants<TData = Awaited<ReturnType<typeof saveModuleTenants>>, TError = ErrorType<SaveModuleTenants500>>(
 id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveModuleTenants>>,
          TError,
          Awaited<ReturnType<typeof saveModuleTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveModuleTenants<TData = Awaited<ReturnType<typeof saveModuleTenants>>, TError = ErrorType<SaveModuleTenants500>>(
 id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Save Module Tenants
 */

export function useSaveModuleTenants<TData = Awaited<ReturnType<typeof saveModuleTenants>>, TError = ErrorType<SaveModuleTenants500>>(
 id: string,
    saveModuleTenantsRequestType?: BodyType<SaveModuleTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModuleTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveModuleTenantsQueryOptions(id,saveModuleTenantsRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all permissions of module (only for CONSOLE)
 * @summary Find All Module Permissions
 */
export const findAllModulePermissions = (
    id: string,
    params?: FindAllModulePermissionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllModulePermissionsResponseType>(
      {url: `/auth-service-v1/modules/${id}/permissions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllModulePermissionsQueryKey = (id: string,
    params?: FindAllModulePermissionsParams,) => {
    return [
    'auth-service-v1','modules',id,'permissions', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllModulePermissionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModulePermissionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModulePermissions>>> = ({ signal }) => findAllModulePermissions(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModulePermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModulePermissions>>>
export type FindAllModulePermissionsQueryError = ErrorType<FindAllModulePermissions500>


export function useFindAllModulePermissions<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params: undefined |  FindAllModulePermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModulePermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllModulePermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulePermissions<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllModulePermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllModulePermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulePermissions<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Module Permissions
 */

export function useFindAllModulePermissions<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModulePermissionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllModulePermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllModulePermissionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllModulePermissions>>> = ({ signal }) => findAllModulePermissions(id,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllModulePermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllModulePermissions>>>
export type FindAllModulePermissionsSuspenseQueryError = ErrorType<FindAllModulePermissions500>


export function useFindAllModulePermissionsSuspense<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params: undefined |  FindAllModulePermissionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulePermissionsSuspense<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllModulePermissionsSuspense<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Module Permissions
 */

export function useFindAllModulePermissionsSuspense<TData = Awaited<ReturnType<typeof findAllModulePermissions>>, TError = ErrorType<FindAllModulePermissions500>>(
 id: string,
    params?: FindAllModulePermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllModulePermissionsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Save Permissions of Module (only for CONSOLE)
 * @summary Save Module Permissions
 */
export const saveModulePermissions = (
    id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllModulePermissionsResponseType>(
      {url: `/auth-service-v1/modules/${id}/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveModulePermissionsRequestType, signal
    },
      options);
    }




export const getSaveModulePermissionsQueryKey = (id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>,) => {
    return [
    'POST', 'auth-service-v1','modules',id,'permissions', saveModulePermissionsRequestType
    ] as const;
    }


export const getSaveModulePermissionsQueryOptions = <TData = Awaited<ReturnType<typeof saveModulePermissions>>, TError = ErrorType<SaveModulePermissions500>>(id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveModulePermissionsQueryKey(id,saveModulePermissionsRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveModulePermissions>>> = ({ signal }) => saveModulePermissions(id,saveModulePermissionsRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveModulePermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof saveModulePermissions>>>
export type SaveModulePermissionsQueryError = ErrorType<SaveModulePermissions500>


export function useSaveModulePermissions<TData = Awaited<ReturnType<typeof saveModulePermissions>>, TError = ErrorType<SaveModulePermissions500>>(
 id: string,
    saveModulePermissionsRequestType: undefined |  BodyType<SaveModulePermissionsRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveModulePermissions>>,
          TError,
          Awaited<ReturnType<typeof saveModulePermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveModulePermissions<TData = Awaited<ReturnType<typeof saveModulePermissions>>, TError = ErrorType<SaveModulePermissions500>>(
 id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveModulePermissions>>,
          TError,
          Awaited<ReturnType<typeof saveModulePermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveModulePermissions<TData = Awaited<ReturnType<typeof saveModulePermissions>>, TError = ErrorType<SaveModulePermissions500>>(
 id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Save Module Permissions
 */

export function useSaveModulePermissions<TData = Awaited<ReturnType<typeof saveModulePermissions>>, TError = ErrorType<SaveModulePermissions500>>(
 id: string,
    saveModulePermissionsRequestType?: BodyType<SaveModulePermissionsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveModulePermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveModulePermissionsQueryOptions(id,saveModulePermissionsRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Save Modules of Tenant (only for CONSOLE)
 * @summary Save Tenant Modules
 */
export const saveTenantModules = (
    id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllTenantModulesResponseType>(
      {url: `/auth-service-v1/tenants/${id}/modules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: findAllTenantModulesRequestType, signal
    },
      options);
    }




export const getSaveTenantModulesQueryKey = (id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>,) => {
    return [
    'POST', 'auth-service-v1','tenants',id,'modules', findAllTenantModulesRequestType
    ] as const;
    }


export const getSaveTenantModulesQueryOptions = <TData = Awaited<ReturnType<typeof saveTenantModules>>, TError = ErrorType<SaveTenantModules500>>(id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveTenantModulesQueryKey(id,findAllTenantModulesRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveTenantModules>>> = ({ signal }) => saveTenantModules(id,findAllTenantModulesRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveTenantModulesQueryResult = NonNullable<Awaited<ReturnType<typeof saveTenantModules>>>
export type SaveTenantModulesQueryError = ErrorType<SaveTenantModules500>


export function useSaveTenantModules<TData = Awaited<ReturnType<typeof saveTenantModules>>, TError = ErrorType<SaveTenantModules500>>(
 id: string,
    findAllTenantModulesRequestType: undefined |  BodyType<FindAllTenantModulesRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveTenantModules>>,
          TError,
          Awaited<ReturnType<typeof saveTenantModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveTenantModules<TData = Awaited<ReturnType<typeof saveTenantModules>>, TError = ErrorType<SaveTenantModules500>>(
 id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveTenantModules>>,
          TError,
          Awaited<ReturnType<typeof saveTenantModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveTenantModules<TData = Awaited<ReturnType<typeof saveTenantModules>>, TError = ErrorType<SaveTenantModules500>>(
 id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Save Tenant Modules
 */

export function useSaveTenantModules<TData = Awaited<ReturnType<typeof saveTenantModules>>, TError = ErrorType<SaveTenantModules500>>(
 id: string,
    findAllTenantModulesRequestType?: BodyType<FindAllTenantModulesRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveTenantModulesQueryOptions(id,findAllTenantModulesRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all modules of tenant (only for CONSOLE)
 * @summary Find All Tenant Modules
 */
export const findAllTenantModules = (
    id: string,
    params?: FindAllTenantModulesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllTenantModulesResponseType>(
      {url: `/auth-service-v1/tenants/${id}/modules`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllTenantModulesQueryKey = (id: string,
    params?: FindAllTenantModulesParams,) => {
    return [
    'auth-service-v1','tenants',id,'modules', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllTenantModulesQueryOptions = <TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTenantModulesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTenantModules>>> = ({ signal }) => findAllTenantModules(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTenantModulesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTenantModules>>>
export type FindAllTenantModulesQueryError = ErrorType<FindAllTenantModules500>


export function useFindAllTenantModules<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params: undefined |  FindAllTenantModulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTenantModules>>,
          TError,
          Awaited<ReturnType<typeof findAllTenantModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTenantModules<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTenantModules>>,
          TError,
          Awaited<ReturnType<typeof findAllTenantModules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTenantModules<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Tenant Modules
 */

export function useFindAllTenantModules<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTenantModulesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTenantModulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTenantModulesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTenantModules>>> = ({ signal }) => findAllTenantModules(id,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTenantModulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTenantModules>>>
export type FindAllTenantModulesSuspenseQueryError = ErrorType<FindAllTenantModules500>


export function useFindAllTenantModulesSuspense<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params: undefined |  FindAllTenantModulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTenantModulesSuspense<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTenantModulesSuspense<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Tenant Modules
 */

export function useFindAllTenantModulesSuspense<TData = Awaited<ReturnType<typeof findAllTenantModules>>, TError = ErrorType<FindAllTenantModules500>>(
 id: string,
    params?: FindAllTenantModulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTenantModules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTenantModulesSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Login User
 */
export const loginUser = (
    loginUserRequestType?: BodyType<LoginUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginUserResponseType>(
      {url: `/auth-service-v1/users/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginUserRequestType, signal
    },
      options);
    }




export const getLoginUserQueryKey = (loginUserRequestType?: BodyType<LoginUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users','login', loginUserRequestType
    ] as const;
    }


export const getLoginUserQueryOptions = <TData = Awaited<ReturnType<typeof loginUser>>, TError = ErrorType<LoginUser500>>(loginUserRequestType?: BodyType<LoginUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginUserQueryKey(loginUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginUser>>> = ({ signal }) => loginUser(loginUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginUserQueryResult = NonNullable<Awaited<ReturnType<typeof loginUser>>>
export type LoginUserQueryError = ErrorType<LoginUser500>


export function useLoginUser<TData = Awaited<ReturnType<typeof loginUser>>, TError = ErrorType<LoginUser500>>(
 loginUserRequestType: undefined |  BodyType<LoginUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginUser>>,
          TError,
          Awaited<ReturnType<typeof loginUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginUser<TData = Awaited<ReturnType<typeof loginUser>>, TError = ErrorType<LoginUser500>>(
 loginUserRequestType?: BodyType<LoginUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginUser>>,
          TError,
          Awaited<ReturnType<typeof loginUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginUser<TData = Awaited<ReturnType<typeof loginUser>>, TError = ErrorType<LoginUser500>>(
 loginUserRequestType?: BodyType<LoginUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Login User
 */

export function useLoginUser<TData = Awaited<ReturnType<typeof loginUser>>, TError = ErrorType<LoginUser500>>(
 loginUserRequestType?: BodyType<LoginUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginUserQueryOptions(loginUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Change Password User
 */
export const changePasswordUser = (
    changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/users/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordUserRequestType, signal
    },
      options);
    }




export const getChangePasswordUserQueryKey = (changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users','change-password', changePasswordUserRequestType
    ] as const;
    }


export const getChangePasswordUserQueryOptions = <TData = Awaited<ReturnType<typeof changePasswordUser>>, TError = ErrorType<ChangePasswordUser500>>(changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangePasswordUserQueryKey(changePasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof changePasswordUser>>> = ({ signal }) => changePasswordUser(changePasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChangePasswordUserQueryResult = NonNullable<Awaited<ReturnType<typeof changePasswordUser>>>
export type ChangePasswordUserQueryError = ErrorType<ChangePasswordUser500>


export function useChangePasswordUser<TData = Awaited<ReturnType<typeof changePasswordUser>>, TError = ErrorType<ChangePasswordUser500>>(
 changePasswordUserRequestType: undefined |  BodyType<ChangePasswordUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changePasswordUser>>,
          TError,
          Awaited<ReturnType<typeof changePasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChangePasswordUser<TData = Awaited<ReturnType<typeof changePasswordUser>>, TError = ErrorType<ChangePasswordUser500>>(
 changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changePasswordUser>>,
          TError,
          Awaited<ReturnType<typeof changePasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChangePasswordUser<TData = Awaited<ReturnType<typeof changePasswordUser>>, TError = ErrorType<ChangePasswordUser500>>(
 changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Change Password User
 */

export function useChangePasswordUser<TData = Awaited<ReturnType<typeof changePasswordUser>>, TError = ErrorType<ChangePasswordUser500>>(
 changePasswordUserRequestType?: BodyType<ChangePasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChangePasswordUserQueryOptions(changePasswordUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Admin Function to require the passwort reset of a specific user. The user cannot login without resetting the password.

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Require Reset Password User
 */
export const requireResetPasswortUser = (
    id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/users/${id}/require-password-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emptyRequestType, signal
    },
      options);
    }




export const getRequireResetPasswortUserQueryKey = (id: string,
    emptyRequestType?: BodyType<EmptyRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users',id,'require-password-reset', emptyRequestType
    ] as const;
    }


export const getRequireResetPasswortUserQueryOptions = <TData = Awaited<ReturnType<typeof requireResetPasswortUser>>, TError = ErrorType<RequireResetPasswortUser500>>(id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequireResetPasswortUserQueryKey(id,emptyRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requireResetPasswortUser>>> = ({ signal }) => requireResetPasswortUser(id,emptyRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequireResetPasswortUserQueryResult = NonNullable<Awaited<ReturnType<typeof requireResetPasswortUser>>>
export type RequireResetPasswortUserQueryError = ErrorType<RequireResetPasswortUser500>


export function useRequireResetPasswortUser<TData = Awaited<ReturnType<typeof requireResetPasswortUser>>, TError = ErrorType<RequireResetPasswortUser500>>(
 id: string,
    emptyRequestType: undefined |  BodyType<EmptyRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requireResetPasswortUser>>,
          TError,
          Awaited<ReturnType<typeof requireResetPasswortUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequireResetPasswortUser<TData = Awaited<ReturnType<typeof requireResetPasswortUser>>, TError = ErrorType<RequireResetPasswortUser500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requireResetPasswortUser>>,
          TError,
          Awaited<ReturnType<typeof requireResetPasswortUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequireResetPasswortUser<TData = Awaited<ReturnType<typeof requireResetPasswortUser>>, TError = ErrorType<RequireResetPasswortUser500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Require Reset Password User
 */

export function useRequireResetPasswortUser<TData = Awaited<ReturnType<typeof requireResetPasswortUser>>, TError = ErrorType<RequireResetPasswortUser500>>(
 id: string,
    emptyRequestType?: BodyType<EmptyRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requireResetPasswortUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequireResetPasswortUserQueryOptions(id,emptyRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Reset Password / Forgot password flow: the user clicks on "forgot password/reset password" and enters his email-adress. A Email with a link in the form SERVERADRESS (Url of Tenant / Auth-Subdomain) + /login?token=resetToken  (resetToken will be generated by the server) will be send. The User clicks on the link in the email and enters a new password on the web frontend page. The server checks the token + newPassword and saves it. The user can login with the new password.
 * @summary Request Reset Password User
 */
export const requestResetPasswordUser = (
    requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/users/request-reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestResetPasswordUserRequestType, signal
    },
      options);
    }




export const getRequestResetPasswordUserQueryKey = (requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users','request-reset-password', requestResetPasswordUserRequestType
    ] as const;
    }


export const getRequestResetPasswordUserQueryOptions = <TData = Awaited<ReturnType<typeof requestResetPasswordUser>>, TError = ErrorType<RequestResetPasswordUser500>>(requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestResetPasswordUserQueryKey(requestResetPasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestResetPasswordUser>>> = ({ signal }) => requestResetPasswordUser(requestResetPasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequestResetPasswordUserQueryResult = NonNullable<Awaited<ReturnType<typeof requestResetPasswordUser>>>
export type RequestResetPasswordUserQueryError = ErrorType<RequestResetPasswordUser500>


export function useRequestResetPasswordUser<TData = Awaited<ReturnType<typeof requestResetPasswordUser>>, TError = ErrorType<RequestResetPasswordUser500>>(
 requestResetPasswordUserRequestType: undefined |  BodyType<RequestResetPasswordUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestResetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof requestResetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestResetPasswordUser<TData = Awaited<ReturnType<typeof requestResetPasswordUser>>, TError = ErrorType<RequestResetPasswordUser500>>(
 requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestResetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof requestResetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestResetPasswordUser<TData = Awaited<ReturnType<typeof requestResetPasswordUser>>, TError = ErrorType<RequestResetPasswordUser500>>(
 requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request Reset Password User
 */

export function useRequestResetPasswordUser<TData = Awaited<ReturnType<typeof requestResetPasswordUser>>, TError = ErrorType<RequestResetPasswordUser500>>(
 requestResetPasswordUserRequestType?: BodyType<RequestResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequestResetPasswordUserQueryOptions(requestResetPasswordUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * After requesting a passwort reset (per admin or by forgot password) the new password can be set. The reset/forgot password token will be invalidated. The user now can login with the new password.
 * @summary Reset Password User
 */
export const resetPasswordUser = (
    resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResetPasswordResponseType>(
      {url: `/auth-service-v1/users/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordUserRequestType, signal
    },
      options);
    }




export const getResetPasswordUserQueryKey = (resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users','reset-password', resetPasswordUserRequestType
    ] as const;
    }


export const getResetPasswordUserQueryOptions = <TData = Awaited<ReturnType<typeof resetPasswordUser>>, TError = ErrorType<ResetPasswordUser500>>(resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResetPasswordUserQueryKey(resetPasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resetPasswordUser>>> = ({ signal }) => resetPasswordUser(resetPasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResetPasswordUserQueryResult = NonNullable<Awaited<ReturnType<typeof resetPasswordUser>>>
export type ResetPasswordUserQueryError = ErrorType<ResetPasswordUser500>


export function useResetPasswordUser<TData = Awaited<ReturnType<typeof resetPasswordUser>>, TError = ErrorType<ResetPasswordUser500>>(
 resetPasswordUserRequestType: undefined |  BodyType<ResetPasswordUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof resetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResetPasswordUser<TData = Awaited<ReturnType<typeof resetPasswordUser>>, TError = ErrorType<ResetPasswordUser500>>(
 resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof resetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResetPasswordUser<TData = Awaited<ReturnType<typeof resetPasswordUser>>, TError = ErrorType<ResetPasswordUser500>>(
 resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reset Password User
 */

export function useResetPasswordUser<TData = Awaited<ReturnType<typeof resetPasswordUser>>, TError = ErrorType<ResetPasswordUser500>>(
 resetPasswordUserRequestType?: BodyType<ResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResetPasswordUserQueryOptions(resetPasswordUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * After requesting a passwort reset (per admin or by forgot password) the new password can be set. This endpoint is to check if the password reset token is still valid

401 -> Token invalid
 * @summary Can Reset Password User
 */
export const canResetPasswordUser = (
    canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EmptyResponseType>(
      {url: `/auth-service-v1/users/can-reset-password`, method: 'GET',
      headers: {'Content-Type': 'application/json', }, signal
    },
      options);
    }




export const getCanResetPasswordUserQueryKey = (canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>,) => {
    return [
    'auth-service-v1','users','can-reset-password', canResetPasswordUserRequestType
    ] as const;
    }


export const getCanResetPasswordUserQueryOptions = <TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanResetPasswordUserQueryKey(canResetPasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canResetPasswordUser>>> = ({ signal }) => canResetPasswordUser(canResetPasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CanResetPasswordUserQueryResult = NonNullable<Awaited<ReturnType<typeof canResetPasswordUser>>>
export type CanResetPasswordUserQueryError = ErrorType<CanResetPasswordUser500>


export function useCanResetPasswordUser<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType: undefined |  BodyType<CanResetPasswordUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canResetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof canResetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanResetPasswordUser<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canResetPasswordUser>>,
          TError,
          Awaited<ReturnType<typeof canResetPasswordUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanResetPasswordUser<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Can Reset Password User
 */

export function useCanResetPasswordUser<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanResetPasswordUserQueryOptions(canResetPasswordUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCanResetPasswordUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanResetPasswordUserQueryKey(canResetPasswordUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canResetPasswordUser>>> = ({ signal }) => canResetPasswordUser(canResetPasswordUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CanResetPasswordUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof canResetPasswordUser>>>
export type CanResetPasswordUserSuspenseQueryError = ErrorType<CanResetPasswordUser500>


export function useCanResetPasswordUserSuspense<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType: undefined |  BodyType<CanResetPasswordUserRequestType>, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanResetPasswordUserSuspense<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanResetPasswordUserSuspense<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Can Reset Password User
 */

export function useCanResetPasswordUserSuspense<TData = Awaited<ReturnType<typeof canResetPasswordUser>>, TError = ErrorType<CanResetPasswordUser500>>(
 canResetPasswordUserRequestType?: BodyType<CanResetPasswordUserRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canResetPasswordUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanResetPasswordUserSuspenseQueryOptions(canResetPasswordUserRequestType,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create an admin or normal user

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Create User
 */
export const createUser = (
    createUserRequestType?: BodyType<CreateUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CreateUserResponseType>(
      {url: `/auth-service-v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequestType, signal
    },
      options);
    }




export const getCreateUserQueryKey = (createUserRequestType?: BodyType<CreateUserRequestType>,) => {
    return [
    'POST', 'auth-service-v1','users', createUserRequestType
    ] as const;
    }


export const getCreateUserQueryOptions = <TData = Awaited<ReturnType<typeof createUser>>, TError = ErrorType<CreateUser500>>(createUserRequestType?: BodyType<CreateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateUserQueryKey(createUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createUser>>> = ({ signal }) => createUser(createUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateUserQueryResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type CreateUserQueryError = ErrorType<CreateUser500>


export function useCreateUser<TData = Awaited<ReturnType<typeof createUser>>, TError = ErrorType<CreateUser500>>(
 createUserRequestType: undefined |  BodyType<CreateUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createUser>>,
          TError,
          Awaited<ReturnType<typeof createUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateUser<TData = Awaited<ReturnType<typeof createUser>>, TError = ErrorType<CreateUser500>>(
 createUserRequestType?: BodyType<CreateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createUser>>,
          TError,
          Awaited<ReturnType<typeof createUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateUser<TData = Awaited<ReturnType<typeof createUser>>, TError = ErrorType<CreateUser500>>(
 createUserRequestType?: BodyType<CreateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create User
 */

export function useCreateUser<TData = Awaited<ReturnType<typeof createUser>>, TError = ErrorType<CreateUser500>>(
 createUserRequestType?: BodyType<CreateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateUserQueryOptions(createUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find All Users
 * @summary Find All Users
 */
export const findAllUsers = (
    params?: FindAllUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllUsersResponseType>(
      {url: `/auth-service-v1/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllUsersQueryKey = (params?: FindAllUsersParams,) => {
    return [
    'auth-service-v1','users', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(params?: FindAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllUsers>>> = ({ signal }) => findAllUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof findAllUsers>>>
export type FindAllUsersQueryError = ErrorType<FindAllUsers500>


export function useFindAllUsers<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params: undefined |  FindAllUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllUsers>>,
          TError,
          Awaited<ReturnType<typeof findAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUsers<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllUsers>>,
          TError,
          Awaited<ReturnType<typeof findAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUsers<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Users
 */

export function useFindAllUsers<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(params?: FindAllUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllUsers>>> = ({ signal }) => findAllUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllUsers>>>
export type FindAllUsersSuspenseQueryError = ErrorType<FindAllUsers500>


export function useFindAllUsersSuspense<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params: undefined |  FindAllUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUsersSuspense<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUsersSuspense<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Users
 */

export function useFindAllUsersSuspense<TData = Awaited<ReturnType<typeof findAllUsers>>, TError = ErrorType<FindAllUsers500>>(
 params?: FindAllUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Update an user

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Update User
 */
export const updateUser = (
    id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateUserResponseType>(
      {url: `/auth-service-v1/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequestType, signal
    },
      options);
    }




export const getUpdateUserQueryKey = (id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>,) => {
    return [
    'PATCH', 'auth-service-v1','users',id, updateUserRequestType
    ] as const;
    }


export const getUpdateUserQueryOptions = <TData = Awaited<ReturnType<typeof updateUser>>, TError = ErrorType<UpdateUser500>>(id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateUserQueryKey(id,updateUserRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateUser>>> = ({ signal }) => updateUser(id,updateUserRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdateUserQueryResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type UpdateUserQueryError = ErrorType<UpdateUser500>


export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ErrorType<UpdateUser500>>(
 id: string,
    updateUserRequestType: undefined |  BodyType<UpdateUserRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUser>>,
          TError,
          Awaited<ReturnType<typeof updateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ErrorType<UpdateUser500>>(
 id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUser>>,
          TError,
          Awaited<ReturnType<typeof updateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ErrorType<UpdateUser500>>(
 id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update User
 */

export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ErrorType<UpdateUser500>>(
 id: string,
    updateUserRequestType?: BodyType<UpdateUserRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdateUserQueryOptions(id,updateUserRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find User By Id
 * @summary Find User By Id
 */
export const findUserById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindUserByIdResponseType>(
      {url: `/auth-service-v1/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getFindUserByIdQueryKey = (id: string,) => {
    return [
    'auth-service-v1','users',id
    ] as const;
    }


export const getFindUserByIdQueryOptions = <TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindUserByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUserById>>> = ({ signal }) => findUserById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findUserById>>>
export type FindUserByIdQueryError = ErrorType<FindUserById500>


export function useFindUserById<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUserById>>,
          TError,
          Awaited<ReturnType<typeof findUserById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserById<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUserById>>,
          TError,
          Awaited<ReturnType<typeof findUserById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserById<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find User By Id
 */

export function useFindUserById<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindUserByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindUserByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUserById>>> = ({ signal }) => findUserById(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindUserByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findUserById>>>
export type FindUserByIdSuspenseQueryError = ErrorType<FindUserById500>


export function useFindUserByIdSuspense<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserByIdSuspense<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserByIdSuspense<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find User By Id
 */

export function useFindUserByIdSuspense<TData = Awaited<ReturnType<typeof findUserById>>, TError = ErrorType<FindUserById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findUserById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Save Groups of User. Old Groups are not deleted, only new ones are added

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Save User Groups
 */
export const saveUserGroups = (
    id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllUserGroupsResponseType>(
      {url: `/auth-service-v1/users/${id}/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveUserGroupsRequestType1, signal
    },
      options);
    }




export const getSaveUserGroupsQueryKey = (id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>,) => {
    return [
    'POST', 'auth-service-v1','users',id,'groups', saveUserGroupsRequestType1
    ] as const;
    }


export const getSaveUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof saveUserGroups>>, TError = ErrorType<SaveUserGroups500>>(id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaveUserGroupsQueryKey(id,saveUserGroupsRequestType1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof saveUserGroups>>> = ({ signal }) => saveUserGroups(id,saveUserGroupsRequestType1, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaveUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof saveUserGroups>>>
export type SaveUserGroupsQueryError = ErrorType<SaveUserGroups500>


export function useSaveUserGroups<TData = Awaited<ReturnType<typeof saveUserGroups>>, TError = ErrorType<SaveUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1: undefined |  BodyType<SaveUserGroupsRequestType1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveUserGroups>>,
          TError,
          Awaited<ReturnType<typeof saveUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveUserGroups<TData = Awaited<ReturnType<typeof saveUserGroups>>, TError = ErrorType<SaveUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveUserGroups>>,
          TError,
          Awaited<ReturnType<typeof saveUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaveUserGroups<TData = Awaited<ReturnType<typeof saveUserGroups>>, TError = ErrorType<SaveUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Save User Groups
 */

export function useSaveUserGroups<TData = Awaited<ReturnType<typeof saveUserGroups>>, TError = ErrorType<SaveUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saveUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaveUserGroupsQueryOptions(id,saveUserGroupsRequestType1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete Groups of User

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Delete User Groups
 */
export const deleteUserGroups = (
    id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllUserGroupsResponseType>(
      {url: `/auth-service-v1/users/${id}/groups`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: saveUserGroupsRequestType1, signal
    },
      options);
    }




export const getDeleteUserGroupsQueryKey = (id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>,) => {
    return [
    'DELETE', 'auth-service-v1','users',id,'groups', saveUserGroupsRequestType1
    ] as const;
    }


export const getDeleteUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof deleteUserGroups>>, TError = ErrorType<DeleteUserGroups500>>(id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteUserGroupsQueryKey(id,saveUserGroupsRequestType1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteUserGroups>>> = ({ signal }) => deleteUserGroups(id,saveUserGroupsRequestType1, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof deleteUserGroups>>>
export type DeleteUserGroupsQueryError = ErrorType<DeleteUserGroups500>


export function useDeleteUserGroups<TData = Awaited<ReturnType<typeof deleteUserGroups>>, TError = ErrorType<DeleteUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1: undefined |  BodyType<SaveUserGroupsRequestType1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteUserGroups>>,
          TError,
          Awaited<ReturnType<typeof deleteUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteUserGroups<TData = Awaited<ReturnType<typeof deleteUserGroups>>, TError = ErrorType<DeleteUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteUserGroups>>,
          TError,
          Awaited<ReturnType<typeof deleteUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteUserGroups<TData = Awaited<ReturnType<typeof deleteUserGroups>>, TError = ErrorType<DeleteUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete User Groups
 */

export function useDeleteUserGroups<TData = Awaited<ReturnType<typeof deleteUserGroups>>, TError = ErrorType<DeleteUserGroups500>>(
 id: string,
    saveUserGroupsRequestType1?: BodyType<SaveUserGroupsRequestType1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteUserGroupsQueryOptions(id,saveUserGroupsRequestType1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all groups of user

Permissions: ADMIN_USERS = 2 (READ)
 * @summary Find All User Groups
 */
export const findAllUserGroups = (
    id: string,
    params?: FindAllUserGroupsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllUserGroupsResponseType>(
      {url: `/auth-service-v1/users/${id}/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllUserGroupsQueryKey = (id: string,
    params?: FindAllUserGroupsParams,) => {
    return [
    'auth-service-v1','users',id,'groups', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllUserGroupsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllUserGroups>>> = ({ signal }) => findAllUserGroups(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllUserGroups>>>
export type FindAllUserGroupsQueryError = ErrorType<FindAllUserGroups500>


export function useFindAllUserGroups<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params: undefined |  FindAllUserGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllUserGroups>>,
          TError,
          Awaited<ReturnType<typeof findAllUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUserGroups<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllUserGroups>>,
          TError,
          Awaited<ReturnType<typeof findAllUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUserGroups<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All User Groups
 */

export function useFindAllUserGroups<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllUserGroupsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllUserGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllUserGroupsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllUserGroups>>> = ({ signal }) => findAllUserGroups(id,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllUserGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllUserGroups>>>
export type FindAllUserGroupsSuspenseQueryError = ErrorType<FindAllUserGroups500>


export function useFindAllUserGroupsSuspense<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params: undefined |  FindAllUserGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUserGroupsSuspense<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllUserGroupsSuspense<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All User Groups
 */

export function useFindAllUserGroupsSuspense<TData = Awaited<ReturnType<typeof findAllUserGroups>>, TError = ErrorType<FindAllUserGroups500>>(
 id: string,
    params?: FindAllUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllUserGroupsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Remove User from Tenant
CONSOLE: TenantId can be provided to delete a user from a specific tenant
WEB: Users can only get deleted from the own tenant

Permissions: ADMIN_USERS = 2 (WRITE)
 * @summary Remove User Tenants
 */
export const removeUserTenants = (
    id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RemoveUserFromTenantResponseType>(
      {url: `/auth-service-v1/users/${id}/tenants`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: removeUserTenantsRequestType, signal
    },
      options);
    }




export const getRemoveUserTenantsQueryKey = (id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>,) => {
    return [
    'DELETE', 'auth-service-v1','users',id,'tenants', removeUserTenantsRequestType
    ] as const;
    }


export const getRemoveUserTenantsQueryOptions = <TData = Awaited<ReturnType<typeof removeUserTenants>>, TError = ErrorType<RemoveUserTenants500>>(id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRemoveUserTenantsQueryKey(id,removeUserTenantsRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof removeUserTenants>>> = ({ signal }) => removeUserTenants(id,removeUserTenantsRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RemoveUserTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof removeUserTenants>>>
export type RemoveUserTenantsQueryError = ErrorType<RemoveUserTenants500>


export function useRemoveUserTenants<TData = Awaited<ReturnType<typeof removeUserTenants>>, TError = ErrorType<RemoveUserTenants500>>(
 id: string,
    removeUserTenantsRequestType: undefined |  BodyType<RemoveUserTenantsRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof removeUserTenants>>,
          TError,
          Awaited<ReturnType<typeof removeUserTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemoveUserTenants<TData = Awaited<ReturnType<typeof removeUserTenants>>, TError = ErrorType<RemoveUserTenants500>>(
 id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof removeUserTenants>>,
          TError,
          Awaited<ReturnType<typeof removeUserTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemoveUserTenants<TData = Awaited<ReturnType<typeof removeUserTenants>>, TError = ErrorType<RemoveUserTenants500>>(
 id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove User Tenants
 */

export function useRemoveUserTenants<TData = Awaited<ReturnType<typeof removeUserTenants>>, TError = ErrorType<RemoveUserTenants500>>(
 id: string,
    removeUserTenantsRequestType?: BodyType<RemoveUserTenantsRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof removeUserTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRemoveUserTenantsQueryOptions(id,removeUserTenantsRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Create a permission (only for CONSOLE)
 * @summary Create Permission
 */
export const createPermission = (
    createPermissionRequestType?: BodyType<CreatePermissionRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindPermissionsByIdResponseType>(
      {url: `/auth-service-v1/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPermissionRequestType, signal
    },
      options);
    }




export const getCreatePermissionQueryKey = (createPermissionRequestType?: BodyType<CreatePermissionRequestType>,) => {
    return [
    'POST', 'auth-service-v1','permissions', createPermissionRequestType
    ] as const;
    }


export const getCreatePermissionQueryOptions = <TData = Awaited<ReturnType<typeof createPermission>>, TError = ErrorType<CreatePermission500>>(createPermissionRequestType?: BodyType<CreatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreatePermissionQueryKey(createPermissionRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createPermission>>> = ({ signal }) => createPermission(createPermissionRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreatePermissionQueryResult = NonNullable<Awaited<ReturnType<typeof createPermission>>>
export type CreatePermissionQueryError = ErrorType<CreatePermission500>


export function useCreatePermission<TData = Awaited<ReturnType<typeof createPermission>>, TError = ErrorType<CreatePermission500>>(
 createPermissionRequestType: undefined |  BodyType<CreatePermissionRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createPermission>>,
          TError,
          Awaited<ReturnType<typeof createPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreatePermission<TData = Awaited<ReturnType<typeof createPermission>>, TError = ErrorType<CreatePermission500>>(
 createPermissionRequestType?: BodyType<CreatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createPermission>>,
          TError,
          Awaited<ReturnType<typeof createPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreatePermission<TData = Awaited<ReturnType<typeof createPermission>>, TError = ErrorType<CreatePermission500>>(
 createPermissionRequestType?: BodyType<CreatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Permission
 */

export function useCreatePermission<TData = Awaited<ReturnType<typeof createPermission>>, TError = ErrorType<CreatePermission500>>(
 createPermissionRequestType?: BodyType<CreatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreatePermissionQueryOptions(createPermissionRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Get all permissions (only for CONSOLE)
 * @summary Find All Permissions
 */
export const findAllPermissions = (
    params?: FindAllPermissionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindAllPermissionsResponseType>(
      {url: `/auth-service-v1/permissions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFindAllPermissionsQueryKey = (params?: FindAllPermissionsParams,) => {
    return [
    'auth-service-v1','permissions', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(params?: FindAllPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllPermissions>>> = ({ signal }) => findAllPermissions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllPermissions>>>
export type FindAllPermissionsQueryError = ErrorType<FindAllPermissions500>


export function useFindAllPermissions<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params: undefined |  FindAllPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPermissions<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof findAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPermissions<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Permissions
 */

export function useFindAllPermissions<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllPermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(params?: FindAllPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllPermissions>>> = ({ signal }) => findAllPermissions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllPermissions>>>
export type FindAllPermissionsSuspenseQueryError = ErrorType<FindAllPermissions500>


export function useFindAllPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params: undefined |  FindAllPermissionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find All Permissions
 */

export function useFindAllPermissionsSuspense<TData = Awaited<ReturnType<typeof findAllPermissions>>, TError = ErrorType<FindAllPermissions500>>(
 params?: FindAllPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllPermissionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Find Permission By Id (only for CONSOLE)
 * @summary Find Permission By Id
 */
export const findPermissionById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindPermissionsByIdResponseType>(
      {url: `/auth-service-v1/permissions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getFindPermissionByIdQueryKey = (id: string,) => {
    return [
    'auth-service-v1','permissions',id
    ] as const;
    }


export const getFindPermissionByIdQueryOptions = <TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPermissionByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPermissionById>>> = ({ signal }) => findPermissionById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPermissionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findPermissionById>>>
export type FindPermissionByIdQueryError = ErrorType<FindPermissionById500>


export function useFindPermissionById<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPermissionById>>,
          TError,
          Awaited<ReturnType<typeof findPermissionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermissionById<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPermissionById>>,
          TError,
          Awaited<ReturnType<typeof findPermissionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermissionById<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Permission By Id
 */

export function useFindPermissionById<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPermissionByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPermissionByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPermissionByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPermissionById>>> = ({ signal }) => findPermissionById(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPermissionByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPermissionById>>>
export type FindPermissionByIdSuspenseQueryError = ErrorType<FindPermissionById500>


export function useFindPermissionByIdSuspense<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermissionByIdSuspense<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPermissionByIdSuspense<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Permission By Id
 */

export function useFindPermissionByIdSuspense<TData = Awaited<ReturnType<typeof findPermissionById>>, TError = ErrorType<FindPermissionById500>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPermissionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPermissionByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Update a permission (only for CONSOLE)
 * @summary Update Permission
 */
export const updatePermission = (
    id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindPermissionsByIdResponseType>(
      {url: `/auth-service-v1/permissions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePermissionRequestType, signal
    },
      options);
    }




export const getUpdatePermissionQueryKey = (id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>,) => {
    return [
    'PUT', 'auth-service-v1','permissions',id, updatePermissionRequestType
    ] as const;
    }


export const getUpdatePermissionQueryOptions = <TData = Awaited<ReturnType<typeof updatePermission>>, TError = ErrorType<UpdatePermission500>>(id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdatePermissionQueryKey(id,updatePermissionRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updatePermission>>> = ({ signal }) => updatePermission(id,updatePermissionRequestType, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdatePermissionQueryResult = NonNullable<Awaited<ReturnType<typeof updatePermission>>>
export type UpdatePermissionQueryError = ErrorType<UpdatePermission500>


export function useUpdatePermission<TData = Awaited<ReturnType<typeof updatePermission>>, TError = ErrorType<UpdatePermission500>>(
 id: string,
    updatePermissionRequestType: undefined |  BodyType<UpdatePermissionRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updatePermission>>,
          TError,
          Awaited<ReturnType<typeof updatePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdatePermission<TData = Awaited<ReturnType<typeof updatePermission>>, TError = ErrorType<UpdatePermission500>>(
 id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updatePermission>>,
          TError,
          Awaited<ReturnType<typeof updatePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdatePermission<TData = Awaited<ReturnType<typeof updatePermission>>, TError = ErrorType<UpdatePermission500>>(
 id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update Permission
 */

export function useUpdatePermission<TData = Awaited<ReturnType<typeof updatePermission>>, TError = ErrorType<UpdatePermission500>>(
 id: string,
    updatePermissionRequestType?: BodyType<UpdatePermissionRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updatePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdatePermissionQueryOptions(id,updatePermissionRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * Delete a permission (only for CONSOLE)
 * @summary Delete Permission
 */
export const deletePermission = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FindPermissionsByIdResponseType>(
      {url: `/auth-service-v1/permissions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePermissionQueryKey = (id: string,) => {
    return [
    'DELETE', 'auth-service-v1','permissions',id
    ] as const;
    }


export const getDeletePermissionQueryOptions = <TData = Awaited<ReturnType<typeof deletePermission>>, TError = ErrorType<DeletePermission500>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeletePermissionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deletePermission>>> = ({ signal }) => deletePermission(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeletePermissionQueryResult = NonNullable<Awaited<ReturnType<typeof deletePermission>>>
export type DeletePermissionQueryError = ErrorType<DeletePermission500>


export function useDeletePermission<TData = Awaited<ReturnType<typeof deletePermission>>, TError = ErrorType<DeletePermission500>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deletePermission>>,
          TError,
          Awaited<ReturnType<typeof deletePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeletePermission<TData = Awaited<ReturnType<typeof deletePermission>>, TError = ErrorType<DeletePermission500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deletePermission>>,
          TError,
          Awaited<ReturnType<typeof deletePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeletePermission<TData = Awaited<ReturnType<typeof deletePermission>>, TError = ErrorType<DeletePermission500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete Permission
 */

export function useDeletePermission<TData = Awaited<ReturnType<typeof deletePermission>>, TError = ErrorType<DeletePermission500>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deletePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeletePermissionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary health-check
 */
export const healthCheck = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<HealthCheck200>(
      {url: `/auth-service-v1/health-check`, method: 'GET', signal
    },
      options);
    }




export const getHealthCheckQueryKey = () => {
    return [
    'auth-service-v1','health-check'
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<HealthCheck500>


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary health-check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getHealthCheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckSuspenseQueryError = ErrorType<HealthCheck500>


export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary health-check
 */

export function useHealthCheckSuspense<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthCheck500>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * (Used only Backend internally)
Load permission-infos for a topic: returns the needed permissions and the tenant or userid if the topic is tenant- or user-specific
 * @summary permission-infos
 */
export const permissionInfos = (
    topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TopicPermissionInfosReponseType>(
      {url: `/auth-service-v1/permission-infos`, method: 'GET',
      headers: {'Content-Type': 'application/json', }, signal
    },
      options);
    }




export const getPermissionInfosQueryKey = (topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>,) => {
    return [
    'auth-service-v1','permission-infos', topicPermissionInfosRequestType
    ] as const;
    }


export const getPermissionInfosQueryOptions = <TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionInfosQueryKey(topicPermissionInfosRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionInfos>>> = ({ signal }) => permissionInfos(topicPermissionInfosRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionInfosQueryResult = NonNullable<Awaited<ReturnType<typeof permissionInfos>>>
export type PermissionInfosQueryError = ErrorType<PermissionInfos500>


export function usePermissionInfos<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType: undefined |  BodyType<TopicPermissionInfosRequestType>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionInfos>>,
          TError,
          Awaited<ReturnType<typeof permissionInfos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionInfos<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionInfos>>,
          TError,
          Awaited<ReturnType<typeof permissionInfos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionInfos<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary permission-infos
 */

export function usePermissionInfos<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionInfosQueryOptions(topicPermissionInfosRequestType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPermissionInfosSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionInfosQueryKey(topicPermissionInfosRequestType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionInfos>>> = ({ signal }) => permissionInfos(topicPermissionInfosRequestType, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionInfosSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof permissionInfos>>>
export type PermissionInfosSuspenseQueryError = ErrorType<PermissionInfos500>


export function usePermissionInfosSuspense<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType: undefined |  BodyType<TopicPermissionInfosRequestType>, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionInfosSuspense<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionInfosSuspense<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary permission-infos
 */

export function usePermissionInfosSuspense<TData = Awaited<ReturnType<typeof permissionInfos>>, TError = ErrorType<PermissionInfos500>>(
 topicPermissionInfosRequestType?: BodyType<TopicPermissionInfosRequestType>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionInfos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionInfosSuspenseQueryOptions(topicPermissionInfosRequestType,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







